! function(e, t) {
	"object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
			if (!e.document) throw new Error("jQuery requires a window with a document");
			return t(e)
	} : t(e)
}("undefined" != typeof window ? window : this, function(e, t) {
	var n = [],
			r = n.slice,
			i = n.concat,
			o = n.push,
			a = n.indexOf,
			s = {},
			u = s.toString,
			c = s.hasOwnProperty,
			l = {},
			f = e.document,
			p = "2.1.4",
			d = function(e, t) {
					return new d.fn.init(e, t)
			},
			h = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
			m = /^-ms-/,
			g = /-([\da-z])/gi,
			v = function(e, t) {
					return t.toUpperCase()
			};


	function y(e) {
			var t = "length" in e && e.length,
					n = d.type(e);
			return "function" !== n && !d.isWindow(e) && (!(1 !== e.nodeType || !t) || ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e))
	}
	d.fn = d.prototype = {
			jquery: p,
			constructor: d,
			selector: "",
			length: 0,
			toArray: function() {
					return r.call(this)
			},
			get: function(e) {
					return null != e ? 0 > e ? this[e + this.length] : this[e] : r.call(this)
			},
			pushStack: function(e) {
					var t = d.merge(this.constructor(), e);
					return t.prevObject = this, t.context = this.context, t
			},
			each: function(e, t) {
					return d.each(this, e, t)
			},
			map: function(e) {
					return this.pushStack(d.map(this, function(t, n) {
							return e.call(t, n, t)
					}))
			},
			slice: function() {
					return this.pushStack(r.apply(this, arguments))
			},
			first: function() {
					return this.eq(0)
			},
			last: function() {
					return this.eq(-1)
			},
			eq: function(e) {
					var t = this.length,
							n = +e + (0 > e ? t : 0);
					return this.pushStack(n >= 0 && t > n ? [this[n]] : [])
			},
			end: function() {
					return this.prevObject || this.constructor(null)
			},
			push: o,
			sort: n.sort,
			splice: n.splice
	}, d.extend = d.fn.extend = function() {
			var e, t, n, r, i, o, a = arguments[0] || {},
					s = 1,
					u = arguments.length,
					c = !1;
			for ("boolean" == typeof a && (c = a, a = arguments[s] || {}, s++), "object" == typeof a || d.isFunction(a) || (a = {}), s === u && (a = this, s--); u > s; s++)
					if (null != (e = arguments[s]))
							for (t in e) n = a[t], a !== (r = e[t]) && (c && r && (d.isPlainObject(r) || (i = d.isArray(r))) ? (i ? (i = !1, o = n && d.isArray(n) ? n : []) : o = n && d.isPlainObject(n) ? n : {}, a[t] = d.extend(c, o, r)) : void 0 !== r && (a[t] = r));
			return a
	}, d.extend({
			expando: "jQuery" + (p + Math.random()).replace(/\D/g, ""),
			isReady: !0,
			error: function(e) {
					throw new Error(e)
			},
			noop: function() {},
			isFunction: function(e) {
					return "function" === d.type(e)
			},
			isArray: Array.isArray,
			isWindow: function(e) {
					return null != e && e === e.window
			},
			isNumeric: function(e) {
					return !d.isArray(e) && e - parseFloat(e) + 1 >= 0
			},
			isPlainObject: function(e) {
					return "object" === d.type(e) && !e.nodeType && !d.isWindow(e) && !(e.constructor && !c.call(e.constructor.prototype, "isPrototypeOf"))
			},
			isEmptyObject: function(e) {
					var t;
					for (t in e) return !1;
					return !0
			},
			type: function(e) {
					return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? s[u.call(e)] || "object" : typeof e
			},
			globalEval: function(e) {
					var t, n = eval;
					(e = d.trim(e)) && (1 === e.indexOf("use strict") ? ((t = f.createElement("script")).text = e, f.head.appendChild(t).parentNode.removeChild(t)) : n(e))
			},
			camelCase: function(e) {
					return e.replace(m, "ms-").replace(g, v)
			},
			nodeName: function(e, t) {
					return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
			},
			each: function(e, t, n) {
					var r = 0,
							i = e.length,
							o = y(e);
					if (n) {
							if (o)
									for (; i > r && !1 !== t.apply(e[r], n); r++);
							else
									for (r in e)
											if (!1 === t.apply(e[r], n)) break
					} else if (o)
							for (; i > r && !1 !== t.call(e[r], r, e[r]); r++);
					else
							for (r in e)
									if (!1 === t.call(e[r], r, e[r])) break; return e
			},
			trim: function(e) {
					return null == e ? "" : (e + "").replace(h, "")
			},
			makeArray: function(e, t) {
					var n = t || [];
					return null != e && (y(Object(e)) ? d.merge(n, "string" == typeof e ? [e] : e) : o.call(n, e)), n
			},
			inArray: function(e, t, n) {
					return null == t ? -1 : a.call(t, e, n)
			},
			merge: function(e, t) {
					for (var n = +t.length, r = 0, i = e.length; n > r; r++) e[i++] = t[r];
					return e.length = i, e
			},
			grep: function(e, t, n) {
					for (var r = [], i = 0, o = e.length, a = !n; o > i; i++) !t(e[i], i) !== a && r.push(e[i]);
					return r
			},
			map: function(e, t, n) {
					var r, o = 0,
							a = e.length,
							s = [];
					if (y(e))
							for (; a > o; o++) null != (r = t(e[o], o, n)) && s.push(r);
					else
							for (o in e) null != (r = t(e[o], o, n)) && s.push(r);
					return i.apply([], s)
			},
			guid: 1,
			proxy: function(e, t) {
					var n, i, o;
					return "string" == typeof t && (n = e[t], t = e, e = n), d.isFunction(e) ? (i = r.call(arguments, 2), (o = function() {
							return e.apply(t || this, i.concat(r.call(arguments)))
					}).guid = e.guid = e.guid || d.guid++, o) : void 0
			},
			now: Date.now,
			support: l
	}), d.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(e, t) {
			s["[object " + t + "]"] = t.toLowerCase()
	});
	var x = function(e) {
			var t, n, r, i, o, a, s, u, c, l, f, p, d, h, m, g, v, y, x, b = "sizzle" + 1 * new Date,
					w = e.document,
					C = 0,
					T = 0,
					k = ae(),
					N = ae(),
					E = ae(),
					S = function(e, t) {
							return e === t && (f = !0), 0
					},
					j = 1 << 31,
					A = {}.hasOwnProperty,
					D = [],
					L = D.pop,
					H = D.push,
					q = D.push,
					O = D.slice,
					P = function(e, t) {
							for (var n = 0, r = e.length; r > n; n++)
									if (e[n] === t) return n;
							return -1
					},
					$ = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
					F = "[\\x20\\t\\r\\n\\f]",
					R = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
					I = R.replace("w", "w#"),
					_ = "\\[" + F + "*(" + R + ")(?:" + F + "*([*^$|!~]?=)" + F + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + I + "))|)" + F + "*\\]",
					M = ":(" + R + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + _ + ")*)|.*)\\)|)",
					W = new RegExp(F + "+", "g"),
					B = new RegExp("^" + F + "+|((?:^|[^\\\\])(?:\\\\.)*)" + F + "+$", "g"),
					U = new RegExp("^" + F + "*," + F + "*"),
					G = new RegExp("^" + F + "*([>+~]|" + F + ")" + F + "*"),
					X = new RegExp("=" + F + "*([^\\]'\"]*?)" + F + "*\\]", "g"),
					z = new RegExp(M),
					Q = new RegExp("^" + I + "$"),
					Y = {
							ID: new RegExp("^#(" + R + ")"),
							CLASS: new RegExp("^\\.(" + R + ")"),
							TAG: new RegExp("^(" + R.replace("w", "w*") + ")"),
							ATTR: new RegExp("^" + _),
							PSEUDO: new RegExp("^" + M),
							CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + F + "*(even|odd|(([+-]|)(\\d*)n|)" + F + "*(?:([+-]|)" + F + "*(\\d+)|))" + F + "*\\)|)", "i"),
							bool: new RegExp("^(?:" + $ + ")$", "i"),
							needsContext: new RegExp("^" + F + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + F + "*((?:-\\d)?\\d*)" + F + "*\\)|)(?=[^-]|$)", "i")
					},
					V = /^(?:input|select|textarea|button)$/i,
					K = /^h\d$/i,
					J = /^[^{]+\{\s*\[native \w/,
					Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
					ee = /[+~]/,
					te = /'|\\/g,
					ne = new RegExp("\\\\([\\da-f]{1,6}" + F + "?|(" + F + ")|.)", "ig"),
					re = function(e, t, n) {
							var r = "0x" + t - 65536;
							return r != r || n ? t : 0 > r ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320)
					},
					ie = function() {
							p()
					};
			try {
					q.apply(D = O.call(w.childNodes), w.childNodes), D[w.childNodes.length].nodeType
			} catch (e) {
					q = {
							apply: D.length ? function(e, t) {
									H.apply(e, O.call(t))
							} : function(e, t) {
									for (var n = e.length, r = 0; e[n++] = t[r++];);
									e.length = n - 1
							}
					}
			}

			function oe(e, t, r, i) {
					var o, s, c, l, f, h, v, y, C, T;
					if ((t ? t.ownerDocument || t : w) !== d && p(t), r = r || [], l = (t = t || d).nodeType, "string" != typeof e || !e || 1 !== l && 9 !== l && 11 !== l) return r;
					if (!i && m) {
							if (11 !== l && (o = Z.exec(e)))
									if (c = o[1]) {
											if (9 === l) {
													if (!(s = t.getElementById(c)) || !s.parentNode) return r;
													if (s.id === c) return r.push(s), r
											} else if (t.ownerDocument && (s = t.ownerDocument.getElementById(c)) && x(t, s) && s.id === c) return r.push(s), r
									} else {
											if (o[2]) return q.apply(r, t.getElementsByTagName(e)), r;
											if ((c = o[3]) && n.getElementsByClassName) return q.apply(r, t.getElementsByClassName(c)), r
									}
							if (n.qsa && (!g || !g.test(e))) {
									if (y = v = b, C = t, T = 1 !== l && e, 1 === l && "object" !== t.nodeName.toLowerCase()) {
											for (h = a(e), (v = t.getAttribute("id")) ? y = v.replace(te, "\\$&") : t.setAttribute("id", y), y = "[id='" + y + "'] ", f = h.length; f--;) h[f] = y + ge(h[f]);
											C = ee.test(e) && he(t.parentNode) || t, T = h.join(",")
									}
									if (T) try {
											return q.apply(r, C.querySelectorAll(T)), r
									} catch (e) {} finally {
											v || t.removeAttribute("id")
									}
							}
					}
					return u(e.replace(B, "$1"), t, r, i)
			}

			function ae() {
					var e = [];
					return function t(n, i) {
							return e.push(n + " ") > r.cacheLength && delete t[e.shift()], t[n + " "] = i
					}
			}

			function se(e) {
					return e[b] = !0, e
			}

			function ue(e) {
					var t = d.createElement("div");
					try {
							return !!e(t)
					} catch (e) {
							return !1
					} finally {
							t.parentNode && t.parentNode.removeChild(t), t = null
					}
			}

			function ce(e, t) {
					for (var n = e.split("|"), i = e.length; i--;) r.attrHandle[n[i]] = t
			}

			function le(e, t) {
					var n = t && e,
							r = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || j) - (~e.sourceIndex || j);
					if (r) return r;
					if (n)
							for (; n = n.nextSibling;)
									if (n === t) return -1;
					return e ? 1 : -1
			}

			function fe(e) {
					return function(t) {
							return "input" === t.nodeName.toLowerCase() && t.type === e
					}
			}

			function pe(e) {
					return function(t) {
							var n = t.nodeName.toLowerCase();
							return ("input" === n || "button" === n) && t.type === e
					}
			}

			function de(e) {
					return se(function(t) {
							return t = +t, se(function(n, r) {
									for (var i, o = e([], n.length, t), a = o.length; a--;) n[i = o[a]] && (n[i] = !(r[i] = n[i]))
							})
					})
			}

			function he(e) {
					return e && void 0 !== e.getElementsByTagName && e
			}
			for (t in n = oe.support = {}, o = oe.isXML = function(e) {
							var t = e && (e.ownerDocument || e).documentElement;
							return !!t && "HTML" !== t.nodeName
					}, p = oe.setDocument = function(e) {
							var t, i, a = e ? e.ownerDocument || e : w;
							return a !== d && 9 === a.nodeType && a.documentElement ? (d = a, h = a.documentElement, (i = a.defaultView) && i !== i.top && (i.addEventListener ? i.addEventListener("unload", ie, !1) : i.attachEvent && i.attachEvent("onunload", ie)), m = !o(a), n.attributes = ue(function(e) {
									return e.className = "i", !e.getAttribute("className")
							}), n.getElementsByTagName = ue(function(e) {
									return e.appendChild(a.createComment("")), !e.getElementsByTagName("*").length
							}), n.getElementsByClassName = J.test(a.getElementsByClassName), n.getById = ue(function(e) {
									return h.appendChild(e).id = b, !a.getElementsByName || !a.getElementsByName(b).length
							}), n.getById ? (r.find.ID = function(e, t) {
									if (void 0 !== t.getElementById && m) {
											var n = t.getElementById(e);
											return n && n.parentNode ? [n] : []
									}
							}, r.filter.ID = function(e) {
									var t = e.replace(ne, re);
									return function(e) {
											return e.getAttribute("id") === t
									}
							}) : (delete r.find.ID, r.filter.ID = function(e) {
									var t = e.replace(ne, re);
									return function(e) {
											var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
											return n && n.value === t
									}
							}), r.find.TAG = n.getElementsByTagName ? function(e, t) {
									return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0
							} : function(e, t) {
									var n, r = [],
											i = 0,
											o = t.getElementsByTagName(e);
									if ("*" === e) {
											for (; n = o[i++];) 1 === n.nodeType && r.push(n);
											return r
									}
									return o
							}, r.find.CLASS = n.getElementsByClassName && function(e, t) {
									return m ? t.getElementsByClassName(e) : void 0
							}, v = [], g = [], (n.qsa = J.test(a.querySelectorAll)) && (ue(function(e) {
									h.appendChild(e).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\f]' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + F + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || g.push("\\[" + F + "*(?:value|" + $ + ")"), e.querySelectorAll("[id~=" + b + "-]").length || g.push("~="), e.querySelectorAll(":checked").length || g.push(":checked"), e.querySelectorAll("a#" + b + "+*").length || g.push(".#.+[+~]")
							}), ue(function(e) {
									var t = a.createElement("input");
									t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && g.push("name" + F + "*[*^$|!~]?="), e.querySelectorAll(":enabled").length || g.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), g.push(",.*:")
							})), (n.matchesSelector = J.test(y = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector)) && ue(function(e) {
									n.disconnectedMatch = y.call(e, "div"), y.call(e, "[s!='']:x"), v.push("!=", M)
							}), g = g.length && new RegExp(g.join("|")), v = v.length && new RegExp(v.join("|")), t = J.test(h.compareDocumentPosition), x = t || J.test(h.contains) ? function(e, t) {
									var n = 9 === e.nodeType ? e.documentElement : e,
											r = t && t.parentNode;
									return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)))
							} : function(e, t) {
									if (t)
											for (; t = t.parentNode;)
													if (t === e) return !0;
									return !1
							}, S = t ? function(e, t) {
									if (e === t) return f = !0, 0;
									var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
									return r || (1 & (r = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !n.sortDetached && t.compareDocumentPosition(e) === r ? e === a || e.ownerDocument === w && x(w, e) ? -1 : t === a || t.ownerDocument === w && x(w, t) ? 1 : l ? P(l, e) - P(l, t) : 0 : 4 & r ? -1 : 1)
							} : function(e, t) {
									if (e === t) return f = !0, 0;
									var n, r = 0,
											i = e.parentNode,
											o = t.parentNode,
											s = [e],
											u = [t];
									if (!i || !o) return e === a ? -1 : t === a ? 1 : i ? -1 : o ? 1 : l ? P(l, e) - P(l, t) : 0;
									if (i === o) return le(e, t);
									for (n = e; n = n.parentNode;) s.unshift(n);
									for (n = t; n = n.parentNode;) u.unshift(n);
									for (; s[r] === u[r];) r++;
									return r ? le(s[r], u[r]) : s[r] === w ? -1 : u[r] === w ? 1 : 0
							}, a) : d
					}, oe.matches = function(e, t) {
							return oe(e, null, null, t)
					}, oe.matchesSelector = function(e, t) {
							if ((e.ownerDocument || e) !== d && p(e), t = t.replace(X, "='$1']"), !(!n.matchesSelector || !m || v && v.test(t) || g && g.test(t))) try {
									var r = y.call(e, t);
									if (r || n.disconnectedMatch || e.document && 11 !== e.document.nodeType) return r
							} catch (e) {}
							return oe(t, d, null, [e]).length > 0
					}, oe.contains = function(e, t) {
							return (e.ownerDocument || e) !== d && p(e), x(e, t)
					}, oe.attr = function(e, t) {
							(e.ownerDocument || e) !== d && p(e);
							var i = r.attrHandle[t.toLowerCase()],
									o = i && A.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !m) : void 0;
							return void 0 !== o ? o : n.attributes || !m ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null
					}, oe.error = function(e) {
							throw new Error("Syntax error, unrecognized expression: " + e)
					}, oe.uniqueSort = function(e) {
							var t, r = [],
									i = 0,
									o = 0;
							if (f = !n.detectDuplicates, l = !n.sortStable && e.slice(0), e.sort(S), f) {
									for (; t = e[o++];) t === e[o] && (i = r.push(o));
									for (; i--;) e.splice(r[i], 1)
							}
							return l = null, e
					}, i = oe.getText = function(e) {
							var t, n = "",
									r = 0,
									o = e.nodeType;
							if (o) {
									if (1 === o || 9 === o || 11 === o) {
											if ("string" == typeof e.textContent) return e.textContent;
											for (e = e.firstChild; e; e = e.nextSibling) n += i(e)
									} else if (3 === o || 4 === o) return e.nodeValue
							} else
									for (; t = e[r++];) n += i(t);
							return n
					}, (r = oe.selectors = {
							cacheLength: 50,
							createPseudo: se,
							match: Y,
							attrHandle: {},
							find: {},
							relative: {
									">": {
											dir: "parentNode",
											first: !0
									},
									" ": {
											dir: "parentNode"
									},
									"+": {
											dir: "previousSibling",
											first: !0
									},
									"~": {
											dir: "previousSibling"
									}
							},
							preFilter: {
									ATTR: function(e) {
											return e[1] = e[1].replace(ne, re), e[3] = (e[3] || e[4] || e[5] || "").replace(ne, re), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
									},
									CHILD: function(e) {
											return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || oe.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && oe.error(e[0]), e
									},
									PSEUDO: function(e) {
											var t, n = !e[6] && e[2];
											return Y.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && z.test(n) && (t = a(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3))
									}
							},
							filter: {
									TAG: function(e) {
											var t = e.replace(ne, re).toLowerCase();
											return "*" === e ? function() {
													return !0
											} : function(e) {
													return e.nodeName && e.nodeName.toLowerCase() === t
											}
									},
									CLASS: function(e) {
											var t = k[e + " "];
											return t || (t = new RegExp("(^|" + F + ")" + e + "(" + F + "|$)")) && k(e, function(e) {
													return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
											})
									},
									ATTR: function(e, t, n) {
											return function(r) {
													var i = oe.attr(r, e);
													return null == i ? "!=" === t : !t || (i += "", "=" === t ? i === n : "!=" === t ? i !== n : "^=" === t ? n && 0 === i.indexOf(n) : "*=" === t ? n && i.indexOf(n) > -1 : "$=" === t ? n && i.slice(-n.length) === n : "~=" === t ? (" " + i.replace(W, " ") + " ").indexOf(n) > -1 : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"))
											}
									},
									CHILD: function(e, t, n, r, i) {
											var o = "nth" !== e.slice(0, 3),
													a = "last" !== e.slice(-4),
													s = "of-type" === t;
											return 1 === r && 0 === i ? function(e) {
													return !!e.parentNode
											} : function(t, n, u) {
													var c, l, f, p, d, h, m = o !== a ? "nextSibling" : "previousSibling",
															g = t.parentNode,
															v = s && t.nodeName.toLowerCase(),
															y = !u && !s;
													if (g) {
															if (o) {
																	for (; m;) {
																			for (f = t; f = f[m];)
																					if (s ? f.nodeName.toLowerCase() === v : 1 === f.nodeType) return !1;
																			h = m = "only" === e && !h && "nextSibling"
																	}
																	return !0
															}
															if (h = [a ? g.firstChild : g.lastChild], a && y) {
																	for (d = (c = (l = g[b] || (g[b] = {}))[e] || [])[0] === C && c[1], p = c[0] === C && c[2], f = d && g.childNodes[d]; f = ++d && f && f[m] || (p = d = 0) || h.pop();)
																			if (1 === f.nodeType && ++p && f === t) {
																					l[e] = [C, d, p];
																					break
																			}
															} else if (y && (c = (t[b] || (t[b] = {}))[e]) && c[0] === C) p = c[1];
															else
																	for (;
																			(f = ++d && f && f[m] || (p = d = 0) || h.pop()) && ((s ? f.nodeName.toLowerCase() !== v : 1 !== f.nodeType) || !++p || (y && ((f[b] || (f[b] = {}))[e] = [C, p]), f !== t)););
															return (p -= i) === r || p % r == 0 && p / r >= 0
													}
											}
									},
									PSEUDO: function(e, t) {
											var n, i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || oe.error("unsupported pseudo: " + e);
											return i[b] ? i(t) : i.length > 1 ? (n = [e, e, "", t], r.setFilters.hasOwnProperty(e.toLowerCase()) ? se(function(e, n) {
													for (var r, o = i(e, t), a = o.length; a--;) e[r = P(e, o[a])] = !(n[r] = o[a])
											}) : function(e) {
													return i(e, 0, n)
											}) : i
									}
							},
							pseudos: {
									not: se(function(e) {
											var t = [],
													n = [],
													r = s(e.replace(B, "$1"));
											return r[b] ? se(function(e, t, n, i) {
													for (var o, a = r(e, null, i, []), s = e.length; s--;)(o = a[s]) && (e[s] = !(t[s] = o))
											}) : function(e, i, o) {
													return t[0] = e, r(t, null, o, n), t[0] = null, !n.pop()
											}
									}),
									has: se(function(e) {
											return function(t) {
													return oe(e, t).length > 0
											}
									}),
									contains: se(function(e) {
											return e = e.replace(ne, re),
													function(t) {
															return (t.textContent || t.innerText || i(t)).indexOf(e) > -1
													}
									}),
									lang: se(function(e) {
											return Q.test(e || "") || oe.error("unsupported lang: " + e), e = e.replace(ne, re).toLowerCase(),
													function(t) {
															var n;
															do {
																	if (n = m ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
															} while ((t = t.parentNode) && 1 === t.nodeType);
															return !1
													}
									}),
									target: function(t) {
											var n = e.location && e.location.hash;
											return n && n.slice(1) === t.id
									},
									root: function(e) {
											return e === h
									},
									focus: function(e) {
											return e === d.activeElement && (!d.hasFocus || d.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
									},
									enabled: function(e) {
											return !1 === e.disabled
									},
									disabled: function(e) {
											return !0 === e.disabled
									},
									checked: function(e) {
											var t = e.nodeName.toLowerCase();
											return "input" === t && !!e.checked || "option" === t && !!e.selected
									},
									selected: function(e) {
											return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
									},
									empty: function(e) {
											for (e = e.firstChild; e; e = e.nextSibling)
													if (e.nodeType < 6) return !1;
											return !0
									},
									parent: function(e) {
											return !r.pseudos.empty(e)
									},
									header: function(e) {
											return K.test(e.nodeName)
									},
									input: function(e) {
											return V.test(e.nodeName)
									},
									button: function(e) {
											var t = e.nodeName.toLowerCase();
											return "input" === t && "button" === e.type || "button" === t
									},
									text: function(e) {
											var t;
											return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
									},
									first: de(function() {
											return [0]
									}),
									last: de(function(e, t) {
											return [t - 1]
									}),
									eq: de(function(e, t, n) {
											return [0 > n ? n + t : n]
									}),
									even: de(function(e, t) {
											for (var n = 0; t > n; n += 2) e.push(n);
											return e
									}),
									odd: de(function(e, t) {
											for (var n = 1; t > n; n += 2) e.push(n);
											return e
									}),
									lt: de(function(e, t, n) {
											for (var r = 0 > n ? n + t : n; --r >= 0;) e.push(r);
											return e
									}),
									gt: de(function(e, t, n) {
											for (var r = 0 > n ? n + t : n; ++r < t;) e.push(r);
											return e
									})
							}
					}).pseudos.nth = r.pseudos.eq, {
							radio: !0,
							checkbox: !0,
							file: !0,
							password: !0,
							image: !0
					}) r.pseudos[t] = fe(t);
			for (t in {
							submit: !0,
							reset: !0
					}) r.pseudos[t] = pe(t);

			function me() {}

			function ge(e) {
					for (var t = 0, n = e.length, r = ""; n > t; t++) r += e[t].value;
					return r
			}

			function ve(e, t, n) {
					var r = t.dir,
							i = n && "parentNode" === r,
							o = T++;
					return t.first ? function(t, n, o) {
							for (; t = t[r];)
									if (1 === t.nodeType || i) return e(t, n, o)
					} : function(t, n, a) {
							var s, u, c = [C, o];
							if (a) {
									for (; t = t[r];)
											if ((1 === t.nodeType || i) && e(t, n, a)) return !0
							} else
									for (; t = t[r];)
											if (1 === t.nodeType || i) {
													if ((s = (u = t[b] || (t[b] = {}))[r]) && s[0] === C && s[1] === o) return c[2] = s[2];
													if (u[r] = c, c[2] = e(t, n, a)) return !0
											}
					}
			}

			function ye(e) {
					return e.length > 1 ? function(t, n, r) {
							for (var i = e.length; i--;)
									if (!e[i](t, n, r)) return !1;
							return !0
					} : e[0]
			}

			function xe(e, t, n, r, i) {
					for (var o, a = [], s = 0, u = e.length, c = null != t; u > s; s++)(o = e[s]) && (!n || n(o, r, i)) && (a.push(o), c && t.push(s));
					return a
			}

			function be(e, t, n, r, i, o) {
					return r && !r[b] && (r = be(r)), i && !i[b] && (i = be(i, o)), se(function(o, a, s, u) {
							var c, l, f, p = [],
									d = [],
									h = a.length,
									m = o || function(e, t, n) {
											for (var r = 0, i = t.length; i > r; r++) oe(e, t[r], n);
											return n
									}(t || "*", s.nodeType ? [s] : s, []),
									g = !e || !o && t ? m : xe(m, p, e, s, u),
									v = n ? i || (o ? e : h || r) ? [] : a : g;
							if (n && n(g, v, s, u), r)
									for (c = xe(v, d), r(c, [], s, u), l = c.length; l--;)(f = c[l]) && (v[d[l]] = !(g[d[l]] = f));
							if (o) {
									if (i || e) {
											if (i) {
													for (c = [], l = v.length; l--;)(f = v[l]) && c.push(g[l] = f);
													i(null, v = [], c, u)
											}
											for (l = v.length; l--;)(f = v[l]) && (c = i ? P(o, f) : p[l]) > -1 && (o[c] = !(a[c] = f))
									}
							} else v = xe(v === a ? v.splice(h, v.length) : v), i ? i(null, a, v, u) : q.apply(a, v)
					})
			}

			function we(e) {
					for (var t, n, i, o = e.length, a = r.relative[e[0].type], s = a || r.relative[" "], u = a ? 1 : 0, l = ve(function(e) {
									return e === t
							}, s, !0), f = ve(function(e) {
									return P(t, e) > -1
							}, s, !0), p = [function(e, n, r) {
									var i = !a && (r || n !== c) || ((t = n).nodeType ? l(e, n, r) : f(e, n, r));
									return t = null, i
							}]; o > u; u++)
							if (n = r.relative[e[u].type]) p = [ve(ye(p), n)];
							else {
									if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
											for (i = ++u; o > i && !r.relative[e[i].type]; i++);
											return be(u > 1 && ye(p), u > 1 && ge(e.slice(0, u - 1).concat({
													value: " " === e[u - 2].type ? "*" : ""
											})).replace(B, "$1"), n, i > u && we(e.slice(u, i)), o > i && we(e = e.slice(i)), o > i && ge(e))
									}
									p.push(n)
							}
					return ye(p)
			}

			function Ce(e, t) {
					var n = t.length > 0,
							i = e.length > 0,
							o = function(o, a, s, u, l) {
									var f, p, h, m = 0,
											g = "0",
											v = o && [],
											y = [],
											x = c,
											b = o || i && r.find.TAG("*", l),
											w = C += null == x ? 1 : Math.random() || .1,
											T = b.length;
									for (l && (c = a !== d && a); g !== T && null != (f = b[g]); g++) {
											if (i && f) {
													for (p = 0; h = e[p++];)
															if (h(f, a, s)) {
																	u.push(f);
																	break
															}
													l && (C = w)
											}
											n && ((f = !h && f) && m--, o && v.push(f))
									}
									if (m += g, n && g !== m) {
											for (p = 0; h = t[p++];) h(v, y, a, s);
											if (o) {
													if (m > 0)
															for (; g--;) v[g] || y[g] || (y[g] = L.call(u));
													y = xe(y)
											}
											q.apply(u, y), l && !o && y.length > 0 && m + t.length > 1 && oe.uniqueSort(u)
									}
									return l && (C = w, c = x), v
							};
					return n ? se(o) : o
			}
			return me.prototype = r.filters = r.pseudos, r.setFilters = new me, a = oe.tokenize = function(e, t) {
					var n, i, o, a, s, u, c, l = N[e + " "];
					if (l) return t ? 0 : l.slice(0);
					for (s = e, u = [], c = r.preFilter; s;) {
							for (a in (!n || (i = U.exec(s))) && (i && (s = s.slice(i[0].length) || s), u.push(o = [])), n = !1, (i = G.exec(s)) && (n = i.shift(), o.push({
											value: n,
											type: i[0].replace(B, " ")
									}), s = s.slice(n.length)), r.filter) !(i = Y[a].exec(s)) || c[a] && !(i = c[a](i)) || (n = i.shift(), o.push({
									value: n,
									type: a,
									matches: i
							}), s = s.slice(n.length));
							if (!n) break
					}
					return t ? s.length : s ? oe.error(e) : N(e, u).slice(0)
			}, s = oe.compile = function(e, t) {
					var n, r = [],
							i = [],
							o = E[e + " "];
					if (!o) {
							for (t || (t = a(e)), n = t.length; n--;)(o = we(t[n]))[b] ? r.push(o) : i.push(o);
							(o = E(e, Ce(i, r))).selector = e
					}
					return o
			}, u = oe.select = function(e, t, i, o) {
					var u, c, l, f, p, d = "function" == typeof e && e,
							h = !o && a(e = d.selector || e);
					if (i = i || [], 1 === h.length) {
							if ((c = h[0] = h[0].slice(0)).length > 2 && "ID" === (l = c[0]).type && n.getById && 9 === t.nodeType && m && r.relative[c[1].type]) {
									if (!(t = (r.find.ID(l.matches[0].replace(ne, re), t) || [])[0])) return i;
									d && (t = t.parentNode), e = e.slice(c.shift().value.length)
							}
							for (u = Y.needsContext.test(e) ? 0 : c.length; u-- && (l = c[u], !r.relative[f = l.type]);)
									if ((p = r.find[f]) && (o = p(l.matches[0].replace(ne, re), ee.test(c[0].type) && he(t.parentNode) || t))) {
											if (c.splice(u, 1), !(e = o.length && ge(c))) return q.apply(i, o), i;
											break
									}
					}
					return (d || s(e, h))(o, t, !m, i, ee.test(e) && he(t.parentNode) || t), i
			}, n.sortStable = b.split("").sort(S).join("") === b, n.detectDuplicates = !!f, p(), n.sortDetached = ue(function(e) {
					return 1 & e.compareDocumentPosition(d.createElement("div"))
			}), ue(function(e) {
					return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
			}) || ce("type|href|height|width", function(e, t, n) {
					return n ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
			}), n.attributes && ue(function(e) {
					return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
			}) || ce("value", function(e, t, n) {
					return n || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue
			}), ue(function(e) {
					return null == e.getAttribute("disabled")
			}) || ce($, function(e, t, n) {
					var r;
					return n ? void 0 : !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null
			}), oe
	}(e);
	d.find = x, d.expr = x.selectors, d.expr[":"] = d.expr.pseudos, d.unique = x.uniqueSort, d.text = x.getText, d.isXMLDoc = x.isXML, d.contains = x.contains;
	var b = d.expr.match.needsContext,
			w = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
			C = /^.[^:#\[\.,]*$/;

	function T(e, t, n) {
			if (d.isFunction(t)) return d.grep(e, function(e, r) {
					return !!t.call(e, r, e) !== n
			});
			if (t.nodeType) return d.grep(e, function(e) {
					return e === t !== n
			});
			if ("string" == typeof t) {
					if (C.test(t)) return d.filter(t, e, n);
					t = d.filter(t, e)
			}
			return d.grep(e, function(e) {
					return a.call(t, e) >= 0 !== n
			})
	}
	d.filter = function(e, t, n) {
			var r = t[0];
			return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? d.find.matchesSelector(r, e) ? [r] : [] : d.find.matches(e, d.grep(t, function(e) {
					return 1 === e.nodeType
			}))
	}, d.fn.extend({
			find: function(e) {
					var t, n = this.length,
							r = [],
							i = this;
					if ("string" != typeof e) return this.pushStack(d(e).filter(function() {
							for (t = 0; n > t; t++)
									if (d.contains(i[t], this)) return !0
					}));
					for (t = 0; n > t; t++) d.find(e, i[t], r);
					return (r = this.pushStack(n > 1 ? d.unique(r) : r)).selector = this.selector ? this.selector + " " + e : e, r
			},
			filter: function(e) {
					return this.pushStack(T(this, e || [], !1))
			},
			not: function(e) {
					return this.pushStack(T(this, e || [], !0))
			},
			is: function(e) {
					return !!T(this, "string" == typeof e && b.test(e) ? d(e) : e || [], !1).length
			}
	});
	var k, N = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
	(d.fn.init = function(e, t) {
			var n, r;
			if (!e) return this;
			if ("string" == typeof e) {
					if (!(n = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : N.exec(e)) || !n[1] && t) return !t || t.jquery ? (t || k).find(e) : this.constructor(t).find(e);
					if (n[1]) {
							if (t = t instanceof d ? t[0] : t, d.merge(this, d.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : f, !0)), w.test(n[1]) && d.isPlainObject(t))
									for (n in t) d.isFunction(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
							return this
					}
					return (r = f.getElementById(n[2])) && r.parentNode && (this.length = 1, this[0] = r), this.context = f, this.selector = e, this
			}
			return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : d.isFunction(e) ? void 0 !== k.ready ? k.ready(e) : e(d) : (void 0 !== e.selector && (this.selector = e.selector, this.context = e.context), d.makeArray(e, this))
	}).prototype = d.fn, k = d(f);
	var E = /^(?:parents|prev(?:Until|All))/,
			S = {
					children: !0,
					contents: !0,
					next: !0,
					prev: !0
			};

	function j(e, t) {
			for (;
					(e = e[t]) && 1 !== e.nodeType;);
			return e
	}
	d.extend({
			dir: function(e, t, n) {
					for (var r = [], i = void 0 !== n;
							(e = e[t]) && 9 !== e.nodeType;)
							if (1 === e.nodeType) {
									if (i && d(e).is(n)) break;
									r.push(e)
							}
					return r
			},
			sibling: function(e, t) {
					for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
					return n
			}
	}), d.fn.extend({
			has: function(e) {
					var t = d(e, this),
							n = t.length;
					return this.filter(function() {
							for (var e = 0; n > e; e++)
									if (d.contains(this, t[e])) return !0
					})
			},
			closest: function(e, t) {
					for (var n, r = 0, i = this.length, o = [], a = b.test(e) || "string" != typeof e ? d(e, t || this.context) : 0; i > r; r++)
							for (n = this[r]; n && n !== t; n = n.parentNode)
									if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && d.find.matchesSelector(n, e))) {
											o.push(n);
											break
									}
					return this.pushStack(o.length > 1 ? d.unique(o) : o)
			},
			index: function(e) {
					return e ? "string" == typeof e ? a.call(d(e), this[0]) : a.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
			},
			add: function(e, t) {
					return this.pushStack(d.unique(d.merge(this.get(), d(e, t))))
			},
			addBack: function(e) {
					return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
			}
	}), d.each({
			parent: function(e) {
					var t = e.parentNode;
					return t && 11 !== t.nodeType ? t : null
			},
			parents: function(e) {
					return d.dir(e, "parentNode")
			},
			parentsUntil: function(e, t, n) {
					return d.dir(e, "parentNode", n)
			},
			next: function(e) {
					return j(e, "nextSibling")
			},
			prev: function(e) {
					return j(e, "previousSibling")
			},
			nextAll: function(e) {
					return d.dir(e, "nextSibling")
			},
			prevAll: function(e) {
					return d.dir(e, "previousSibling")
			},
			nextUntil: function(e, t, n) {
					return d.dir(e, "nextSibling", n)
			},
			prevUntil: function(e, t, n) {
					return d.dir(e, "previousSibling", n)
			},
			siblings: function(e) {
					return d.sibling((e.parentNode || {}).firstChild, e)
			},
			children: function(e) {
					return d.sibling(e.firstChild)
			},
			contents: function(e) {
					return e.contentDocument || d.merge([], e.childNodes)
			}
	}, function(e, t) {
			d.fn[e] = function(n, r) {
					var i = d.map(this, t, n);
					return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (i = d.filter(r, i)), this.length > 1 && (S[e] || d.unique(i), E.test(e) && i.reverse()), this.pushStack(i)
			}
	});
	var A, D = /\S+/g,
			L = {};

	function H() {
			f.removeEventListener("DOMContentLoaded", H, !1), e.removeEventListener("load", H, !1), d.ready()
	}
	d.Callbacks = function(e) {
			e = "string" == typeof e ? L[e] || function(e) {
					var t = L[e] = {};
					return d.each(e.match(D) || [], function(e, n) {
							t[n] = !0
					}), t
			}(e) : d.extend({}, e);
			var t, n, r, i, o, a, s = [],
					u = !e.once && [],
					c = function(f) {
							for (t = e.memory && f, n = !0, a = i || 0, i = 0, o = s.length, r = !0; s && o > a; a++)
									if (!1 === s[a].apply(f[0], f[1]) && e.stopOnFalse) {
											t = !1;
											break
									}
							r = !1, s && (u ? u.length && c(u.shift()) : t ? s = [] : l.disable())
					},
					l = {
							add: function() {
									if (s) {
											var n = s.length;
											! function t(n) {
													d.each(n, function(n, r) {
															var i = d.type(r);
															"function" === i ? e.unique && l.has(r) || s.push(r) : r && r.length && "string" !== i && t(r)
													})
											}(arguments), r ? o = s.length : t && (i = n, c(t))
									}
									return this
							},
							remove: function() {
									return s && d.each(arguments, function(e, t) {
											for (var n;
													(n = d.inArray(t, s, n)) > -1;) s.splice(n, 1), r && (o >= n && o--, a >= n && a--)
									}), this
							},
							has: function(e) {
									return e ? d.inArray(e, s) > -1 : !(!s || !s.length)
							},
							empty: function() {
									return s = [], o = 0, this
							},
							disable: function() {
									return s = u = t = void 0, this
							},
							disabled: function() {
									return !s
							},
							lock: function() {
									return u = void 0, t || l.disable(), this
							},
							locked: function() {
									return !u
							},
							fireWith: function(e, t) {
									return !s || n && !u || (t = [e, (t = t || []).slice ? t.slice() : t], r ? u.push(t) : c(t)), this
							},
							fire: function() {
									return l.fireWith(this, arguments), this
							},
							fired: function() {
									return !!n
							}
					};
			return l
	}, d.extend({
			Deferred: function(e) {
					var t = [
									["resolve", "done", d.Callbacks("once memory"), "resolved"],
									["reject", "fail", d.Callbacks("once memory"), "rejected"],
									["notify", "progress", d.Callbacks("memory")]
							],
							n = "pending",
							r = {
									state: function() {
											return n
									},
									always: function() {
											return i.done(arguments).fail(arguments), this
									},
									then: function() {
											var e = arguments;
											return d.Deferred(function(n) {
													d.each(t, function(t, o) {
															var a = d.isFunction(e[t]) && e[t];
															i[o[1]](function() {
																	var e = a && a.apply(this, arguments);
																	e && d.isFunction(e.promise) ? e.promise().done(n.resolve).fail(n.reject).progress(n.notify) : n[o[0] + "With"](this === r ? n.promise() : this, a ? [e] : arguments)
															})
													}), e = null
											}).promise()
									},
									promise: function(e) {
											return null != e ? d.extend(e, r) : r
									}
							},
							i = {};
					return r.pipe = r.then, d.each(t, function(e, o) {
							var a = o[2],
									s = o[3];
							r[o[1]] = a.add, s && a.add(function() {
									n = s
							}, t[1 ^ e][2].disable, t[2][2].lock), i[o[0]] = function() {
									return i[o[0] + "With"](this === i ? r : this, arguments), this
							}, i[o[0] + "With"] = a.fireWith
					}), r.promise(i), e && e.call(i, i), i
			},
			when: function(e) {
					var t, n, i, o = 0,
							a = r.call(arguments),
							s = a.length,
							u = 1 !== s || e && d.isFunction(e.promise) ? s : 0,
							c = 1 === u ? e : d.Deferred(),
							l = function(e, n, i) {
									return function(o) {
											n[e] = this, i[e] = arguments.length > 1 ? r.call(arguments) : o, i === t ? c.notifyWith(n, i) : --u || c.resolveWith(n, i)
									}
							};
					if (s > 1)
							for (t = new Array(s), n = new Array(s), i = new Array(s); s > o; o++) a[o] && d.isFunction(a[o].promise) ? a[o].promise().done(l(o, i, a)).fail(c.reject).progress(l(o, n, t)) : --u;
					return u || c.resolveWith(i, a), c.promise()
			}
	}), d.fn.ready = function(e) {
			return d.ready.promise().done(e), this
	}, d.extend({
			isReady: !1,
			readyWait: 1,
			holdReady: function(e) {
					e ? d.readyWait++ : d.ready(!0)
			},
			ready: function(e) {
					(!0 === e ? --d.readyWait : d.isReady) || (d.isReady = !0, !0 !== e && --d.readyWait > 0 || (A.resolveWith(f, [d]), d.fn.triggerHandler && (d(f).triggerHandler("ready"), d(f).off("ready"))))
			}
	}), d.ready.promise = function(t) {
			return A || (A = d.Deferred(), "complete" === f.readyState ? setTimeout(d.ready) : (f.addEventListener("DOMContentLoaded", H, !1), e.addEventListener("load", H, !1))), A.promise(t)
	}, d.ready.promise();
	var q = d.access = function(e, t, n, r, i, o, a) {
			var s = 0,
					u = e.length,
					c = null == n;
			if ("object" === d.type(n))
					for (s in i = !0, n) d.access(e, t, s, n[s], !0, o, a);
			else if (void 0 !== r && (i = !0, d.isFunction(r) || (a = !0), c && (a ? (t.call(e, r), t = null) : (c = t, t = function(e, t, n) {
							return c.call(d(e), n)
					})), t))
					for (; u > s; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
			return i ? e : c ? t.call(e) : u ? t(e[0], n) : o
	};

	function O() {
			Object.defineProperty(this.cache = {}, 0, {
					get: function() {
							return {}
					}
			}), this.expando = d.expando + O.uid++
	}
	d.acceptData = function(e) {
			return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
	}, O.uid = 1, O.accepts = d.acceptData, O.prototype = {
			key: function(e) {
					if (!O.accepts(e)) return 0;
					var t = {},
							n = e[this.expando];
					if (!n) {
							n = O.uid++;
							try {
									t[this.expando] = {
											value: n
									}, Object.defineProperties(e, t)
							} catch (r) {
									t[this.expando] = n, d.extend(e, t)
							}
					}
					return this.cache[n] || (this.cache[n] = {}), n
			},
			set: function(e, t, n) {
					var r, i = this.key(e),
							o = this.cache[i];
					if ("string" == typeof t) o[t] = n;
					else if (d.isEmptyObject(o)) d.extend(this.cache[i], t);
					else
							for (r in t) o[r] = t[r];
					return o
			},
			get: function(e, t) {
					var n = this.cache[this.key(e)];
					return void 0 === t ? n : n[t]
			},
			access: function(e, t, n) {
					var r;
					return void 0 === t || t && "string" == typeof t && void 0 === n ? void 0 !== (r = this.get(e, t)) ? r : this.get(e, d.camelCase(t)) : (this.set(e, t, n), void 0 !== n ? n : t)
			},
			remove: function(e, t) {
					var n, r, i, o = this.key(e),
							a = this.cache[o];
					if (void 0 === t) this.cache[o] = {};
					else {
							d.isArray(t) ? r = t.concat(t.map(d.camelCase)) : (i = d.camelCase(t), t in a ? r = [t, i] : r = (r = i) in a ? [r] : r.match(D) || []), n = r.length;
							for (; n--;) delete a[r[n]]
					}
			},
			hasData: function(e) {
					return !d.isEmptyObject(this.cache[e[this.expando]] || {})
			},
			discard: function(e) {
					e[this.expando] && delete this.cache[e[this.expando]]
			}
	};
	var P = new O,
			$ = new O,
			F = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
			R = /([A-Z])/g;

	function I(e, t, n) {
			var r;
			if (void 0 === n && 1 === e.nodeType)
					if (r = "data-" + t.replace(R, "-$1").toLowerCase(), "string" == typeof(n = e.getAttribute(r))) {
							try {
									n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : F.test(n) ? d.parseJSON(n) : n)
							} catch (e) {}
							$.set(e, t, n)
					} else n = void 0;
			return n
	}
	d.extend({
			hasData: function(e) {
					return $.hasData(e) || P.hasData(e)
			},
			data: function(e, t, n) {
					return $.access(e, t, n)
			},
			removeData: function(e, t) {
					$.remove(e, t)
			},
			_data: function(e, t, n) {
					return P.access(e, t, n)
			},
			_removeData: function(e, t) {
					P.remove(e, t)
			}
	}), d.fn.extend({
			data: function(e, t) {
					var n, r, i, o = this[0],
							a = o && o.attributes;
					if (void 0 === e) {
							if (this.length && (i = $.get(o), 1 === o.nodeType && !P.get(o, "hasDataAttrs"))) {
									for (n = a.length; n--;) a[n] && (0 === (r = a[n].name).indexOf("data-") && (r = d.camelCase(r.slice(5)), I(o, r, i[r])));
									P.set(o, "hasDataAttrs", !0)
							}
							return i
					}
					return "object" == typeof e ? this.each(function() {
							$.set(this, e)
					}) : q(this, function(t) {
							var n, r = d.camelCase(e);
							if (o && void 0 === t) {
									if (void 0 !== (n = $.get(o, e))) return n;
									if (void 0 !== (n = $.get(o, r))) return n;
									if (void 0 !== (n = I(o, r, void 0))) return n
							} else this.each(function() {
									var n = $.get(this, r);
									$.set(this, r, t), -1 !== e.indexOf("-") && void 0 !== n && $.set(this, e, t)
							})
					}, null, t, arguments.length > 1, null, !0)
			},
			removeData: function(e) {
					return this.each(function() {
							$.remove(this, e)
					})
			}
	}), d.extend({
			queue: function(e, t, n) {
					var r;
					return e ? (t = (t || "fx") + "queue", r = P.get(e, t), n && (!r || d.isArray(n) ? r = P.access(e, t, d.makeArray(n)) : r.push(n)), r || []) : void 0
			},
			dequeue: function(e, t) {
					t = t || "fx";
					var n = d.queue(e, t),
							r = n.length,
							i = n.shift(),
							o = d._queueHooks(e, t);
					"inprogress" === i && (i = n.shift(), r--), i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, function() {
							d.dequeue(e, t)
					}, o)), !r && o && o.empty.fire()
			},
			_queueHooks: function(e, t) {
					var n = t + "queueHooks";
					return P.get(e, n) || P.access(e, n, {
							empty: d.Callbacks("once memory").add(function() {
									P.remove(e, [t + "queue", n])
							})
					})
			}
	}), d.fn.extend({
			queue: function(e, t) {
					var n = 2;
					return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? d.queue(this[0], e) : void 0 === t ? this : this.each(function() {
							var n = d.queue(this, e, t);
							d._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && d.dequeue(this, e)
					})
			},
			dequeue: function(e) {
					return this.each(function() {
							d.dequeue(this, e)
					})
			},
			clearQueue: function(e) {
					return this.queue(e || "fx", [])
			},
			promise: function(e, t) {
					var n, r = 1,
							i = d.Deferred(),
							o = this,
							a = this.length,
							s = function() {
									--r || i.resolveWith(o, [o])
							};
					for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; a--;)(n = P.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s));
					return s(), i.promise(t)
			}
	});
	var _ = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
			M = ["Top", "Right", "Bottom", "Left"],
			W = function(e, t) {
					return e = t || e, "none" === d.css(e, "display") || !d.contains(e.ownerDocument, e)
			},
			B = /^(?:checkbox|radio)$/i;
	! function() {
			var e = f.createDocumentFragment().appendChild(f.createElement("div")),
					t = f.createElement("input");
			t.setAttribute("type", "radio"), t.setAttribute("checked", "checked"), t.setAttribute("name", "t"), e.appendChild(t), l.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked, e.innerHTML = "<textarea>x</textarea>", l.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue
	}();
	var U = "undefined";
	l.focusinBubbles = "onfocusin" in e;
	var G = /^key/,
			X = /^(?:mouse|pointer|contextmenu)|click/,
			z = /^(?:focusinfocus|focusoutblur)$/,
			Q = /^([^.]*)(?:\.(.+)|)$/;

	function Y() {
			return !0
	}

	function V() {
			return !1
	}

	function K() {
			try {
					return f.activeElement
			} catch (e) {}
	}
	d.event = {
			global: {},
			add: function(e, t, n, r, i) {
					var o, a, s, u, c, l, f, p, h, m, g, v = P.get(e);
					if (v)
							for (n.handler && (n = (o = n).handler, i = o.selector), n.guid || (n.guid = d.guid++), (u = v.events) || (u = v.events = {}), (a = v.handle) || (a = v.handle = function(t) {
											return typeof d !== U && d.event.triggered !== t.type ? d.event.dispatch.apply(e, arguments) : void 0
									}), c = (t = (t || "").match(D) || [""]).length; c--;) h = g = (s = Q.exec(t[c]) || [])[1], m = (s[2] || "").split(".").sort(), h && (f = d.event.special[h] || {}, h = (i ? f.delegateType : f.bindType) || h, f = d.event.special[h] || {}, l = d.extend({
									type: h,
									origType: g,
									data: r,
									handler: n,
									guid: n.guid,
									selector: i,
									needsContext: i && d.expr.match.needsContext.test(i),
									namespace: m.join(".")
							}, o), (p = u[h]) || ((p = u[h] = []).delegateCount = 0, f.setup && !1 !== f.setup.call(e, r, m, a) || e.addEventListener && e.addEventListener(h, a, !1)), f.add && (f.add.call(e, l), l.handler.guid || (l.handler.guid = n.guid)), i ? p.splice(p.delegateCount++, 0, l) : p.push(l), d.event.global[h] = !0)
			},
			remove: function(e, t, n, r, i) {
					var o, a, s, u, c, l, f, p, h, m, g, v = P.hasData(e) && P.get(e);
					if (v && (u = v.events)) {
							for (c = (t = (t || "").match(D) || [""]).length; c--;)
									if (h = g = (s = Q.exec(t[c]) || [])[1], m = (s[2] || "").split(".").sort(), h) {
											for (f = d.event.special[h] || {}, p = u[h = (r ? f.delegateType : f.bindType) || h] || [], s = s[2] && new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = o = p.length; o--;) l = p[o], !i && g !== l.origType || n && n.guid !== l.guid || s && !s.test(l.namespace) || r && r !== l.selector && ("**" !== r || !l.selector) || (p.splice(o, 1), l.selector && p.delegateCount--, f.remove && f.remove.call(e, l));
											a && !p.length && (f.teardown && !1 !== f.teardown.call(e, m, v.handle) || d.removeEvent(e, h, v.handle), delete u[h])
									} else
											for (h in u) d.event.remove(e, h + t[c], n, r, !0);
							d.isEmptyObject(u) && (delete v.handle, P.remove(e, "events"))
					}
			},
			trigger: function(t, n, r, i) {
					var o, a, s, u, l, p, h, m = [r || f],
							g = c.call(t, "type") ? t.type : t,
							v = c.call(t, "namespace") ? t.namespace.split(".") : [];
					if (a = s = r = r || f, 3 !== r.nodeType && 8 !== r.nodeType && !z.test(g + d.event.triggered) && (g.indexOf(".") >= 0 && (v = g.split("."), g = v.shift(), v.sort()), l = g.indexOf(":") < 0 && "on" + g, (t = t[d.expando] ? t : new d.Event(g, "object" == typeof t && t)).isTrigger = i ? 2 : 3, t.namespace = v.join("."), t.namespace_re = t.namespace ? new RegExp("(^|\\.)" + v.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = r), n = null == n ? [t] : d.makeArray(n, [t]), h = d.event.special[g] || {}, i || !h.trigger || !1 !== h.trigger.apply(r, n))) {
							if (!i && !h.noBubble && !d.isWindow(r)) {
									for (u = h.delegateType || g, z.test(u + g) || (a = a.parentNode); a; a = a.parentNode) m.push(a), s = a;
									s === (r.ownerDocument || f) && m.push(s.defaultView || s.parentWindow || e)
							}
							for (o = 0;
									(a = m[o++]) && !t.isPropagationStopped();) t.type = o > 1 ? u : h.bindType || g, (p = (P.get(a, "events") || {})[t.type] && P.get(a, "handle")) && p.apply(a, n), (p = l && a[l]) && p.apply && d.acceptData(a) && (t.result = p.apply(a, n), !1 === t.result && t.preventDefault());
							return t.type = g, i || t.isDefaultPrevented() || h._default && !1 !== h._default.apply(m.pop(), n) || !d.acceptData(r) || l && d.isFunction(r[g]) && !d.isWindow(r) && ((s = r[l]) && (r[l] = null), d.event.triggered = g, r[g](), d.event.triggered = void 0, s && (r[l] = s)), t.result
					}
			},
			dispatch: function(e) {
					e = d.event.fix(e);
					var t, n, i, o, a, s = [],
							u = r.call(arguments),
							c = (P.get(this, "events") || {})[e.type] || [],
							l = d.event.special[e.type] || {};
					if (u[0] = e, e.delegateTarget = this, !l.preDispatch || !1 !== l.preDispatch.call(this, e)) {
							for (s = d.event.handlers.call(this, e, c), t = 0;
									(o = s[t++]) && !e.isPropagationStopped();)
									for (e.currentTarget = o.elem, n = 0;
											(a = o.handlers[n++]) && !e.isImmediatePropagationStopped();)(!e.namespace_re || e.namespace_re.test(a.namespace)) && (e.handleObj = a, e.data = a.data, void 0 !== (i = ((d.event.special[a.origType] || {}).handle || a.handler).apply(o.elem, u)) && !1 === (e.result = i) && (e.preventDefault(), e.stopPropagation()));
							return l.postDispatch && l.postDispatch.call(this, e), e.result
					}
			},
			handlers: function(e, t) {
					var n, r, i, o, a = [],
							s = t.delegateCount,
							u = e.target;
					if (s && u.nodeType && (!e.button || "click" !== e.type))
							for (; u !== this; u = u.parentNode || this)
									if (!0 !== u.disabled || "click" !== e.type) {
											for (r = [], n = 0; s > n; n++) void 0 === r[i = (o = t[n]).selector + " "] && (r[i] = o.needsContext ? d(i, this).index(u) >= 0 : d.find(i, this, null, [u]).length), r[i] && r.push(o);
											r.length && a.push({
													elem: u,
													handlers: r
											})
									}
					return s < t.length && a.push({
							elem: this,
							handlers: t.slice(s)
					}), a
			},
			props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
			fixHooks: {},
			keyHooks: {
					props: "char charCode key keyCode".split(" "),
					filter: function(e, t) {
							return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e
					}
			},
			mouseHooks: {
					props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
					filter: function(e, t) {
							var n, r, i, o = t.button;
							return null == e.pageX && null != t.clientX && (r = (n = e.target.ownerDocument || f).documentElement, i = n.body, e.pageX = t.clientX + (r && r.scrollLeft || i && i.scrollLeft || 0) - (r && r.clientLeft || i && i.clientLeft || 0), e.pageY = t.clientY + (r && r.scrollTop || i && i.scrollTop || 0) - (r && r.clientTop || i && i.clientTop || 0)), e.which || void 0 === o || (e.which = 1 & o ? 1 : 2 & o ? 3 : 4 & o ? 2 : 0), e
					}
			},
			fix: function(e) {
					if (e[d.expando]) return e;
					var t, n, r, i = e.type,
							o = e,
							a = this.fixHooks[i];
					for (a || (this.fixHooks[i] = a = X.test(i) ? this.mouseHooks : G.test(i) ? this.keyHooks : {}), r = a.props ? this.props.concat(a.props) : this.props, e = new d.Event(o), t = r.length; t--;) e[n = r[t]] = o[n];
					return e.target || (e.target = f), 3 === e.target.nodeType && (e.target = e.target.parentNode), a.filter ? a.filter(e, o) : e
			},
			special: {
					load: {
							noBubble: !0
					},
					focus: {
							trigger: function() {
									return this !== K() && this.focus ? (this.focus(), !1) : void 0
							},
							delegateType: "focusin"
					},
					blur: {
							trigger: function() {
									return this === K() && this.blur ? (this.blur(), !1) : void 0
							},
							delegateType: "focusout"
					},
					click: {
							trigger: function() {
									return "checkbox" === this.type && this.click && d.nodeName(this, "input") ? (this.click(), !1) : void 0
							},
							_default: function(e) {
									return d.nodeName(e.target, "a")
							}
					},
					beforeunload: {
							postDispatch: function(e) {
									void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
							}
					}
			},
			simulate: function(e, t, n, r) {
					var i = d.extend(new d.Event, n, {
							type: e,
							isSimulated: !0,
							originalEvent: {}
					});
					r ? d.event.trigger(i, null, t) : d.event.dispatch.call(t, i), i.isDefaultPrevented() && n.preventDefault()
			}
	}, d.removeEvent = function(e, t, n) {
			e.removeEventListener && e.removeEventListener(t, n, !1)
	}, d.Event = function(e, t) {
			return this instanceof d.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Y : V) : this.type = e, t && d.extend(this, t), this.timeStamp = e && e.timeStamp || d.now(), void(this[d.expando] = !0)) : new d.Event(e, t)
	}, d.Event.prototype = {
			isDefaultPrevented: V,
			isPropagationStopped: V,
			isImmediatePropagationStopped: V,
			preventDefault: function() {
					var e = this.originalEvent;
					this.isDefaultPrevented = Y, e && e.preventDefault && e.preventDefault()
			},
			stopPropagation: function() {
					var e = this.originalEvent;
					this.isPropagationStopped = Y, e && e.stopPropagation && e.stopPropagation()
			},
			stopImmediatePropagation: function() {
					var e = this.originalEvent;
					this.isImmediatePropagationStopped = Y, e && e.stopImmediatePropagation && e.stopImmediatePropagation(), this.stopPropagation()
			}
	}, d.each({
			mouseenter: "mouseover",
			mouseleave: "mouseout",
			pointerenter: "pointerover",
			pointerleave: "pointerout"
	}, function(e, t) {
			d.event.special[e] = {
					delegateType: t,
					bindType: t,
					handle: function(e) {
							var n, r = e.relatedTarget,
									i = e.handleObj;
							return (!r || r !== this && !d.contains(this, r)) && (e.type = i.origType, n = i.handler.apply(this, arguments), e.type = t), n
					}
			}
	}), l.focusinBubbles || d.each({
			focus: "focusin",
			blur: "focusout"
	}, function(e, t) {
			var n = function(e) {
					d.event.simulate(t, e.target, d.event.fix(e), !0)
			};
			d.event.special[t] = {
					setup: function() {
							var r = this.ownerDocument || this,
									i = P.access(r, t);
							i || r.addEventListener(e, n, !0), P.access(r, t, (i || 0) + 1)
					},
					teardown: function() {
							var r = this.ownerDocument || this,
									i = P.access(r, t) - 1;
							i ? P.access(r, t, i) : (r.removeEventListener(e, n, !0), P.remove(r, t))
					}
			}
	}), d.fn.extend({
			on: function(e, t, n, r, i) {
					var o, a;
					if ("object" == typeof e) {
							for (a in "string" != typeof t && (n = n || t, t = void 0), e) this.on(a, t, n, e[a], i);
							return this
					}
					if (null == n && null == r ? (r = t, n = t = void 0) : null == r && ("string" == typeof t ? (r = n, n = void 0) : (r = n, n = t, t = void 0)), !1 === r) r = V;
					else if (!r) return this;
					return 1 === i && (o = r, (r = function(e) {
							return d().off(e), o.apply(this, arguments)
					}).guid = o.guid || (o.guid = d.guid++)), this.each(function() {
							d.event.add(this, e, r, n, t)
					})
			},
			one: function(e, t, n, r) {
					return this.on(e, t, n, r, 1)
			},
			off: function(e, t, n) {
					var r, i;
					if (e && e.preventDefault && e.handleObj) return r = e.handleObj, d(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;
					if ("object" == typeof e) {
							for (i in e) this.off(i, t, e[i]);
							return this
					}
					return (!1 === t || "function" == typeof t) && (n = t, t = void 0), !1 === n && (n = V), this.each(function() {
							d.event.remove(this, e, n, t)
					})
			},
			trigger: function(e, t) {
					return this.each(function() {
							d.event.trigger(e, t, this)
					})
			},
			triggerHandler: function(e, t) {
					var n = this[0];
					return n ? d.event.trigger(e, t, n, !0) : void 0
			}
	});
	var J = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
			Z = /<([\w:]+)/,
			ee = /<|&#?\w+;/,
			te = /<(?:script|style|link)/i,
			ne = /checked\s*(?:[^=]|=\s*.checked.)/i,
			re = /^$|\/(?:java|ecma)script/i,
			ie = /^true\/(.*)/,
			oe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
			ae = {
					option: [1, "<select multiple='multiple'>", "</select>"],
					thead: [1, "<table>", "</table>"],
					col: [2, "<table><colgroup>", "</colgroup></table>"],
					tr: [2, "<table><tbody>", "</tbody></table>"],
					td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
					_default: [0, "", ""]
			};

	function se(e, t) {
			return d.nodeName(e, "table") && d.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e
	}

	function ue(e) {
			return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e
	}

	function ce(e) {
			var t = ie.exec(e.type);
			return t ? e.type = t[1] : e.removeAttribute("type"), e
	}

	function le(e, t) {
			for (var n = 0, r = e.length; r > n; n++) P.set(e[n], "globalEval", !t || P.get(t[n], "globalEval"))
	}

	function fe(e, t) {
			var n, r, i, o, a, s, u, c;
			if (1 === t.nodeType) {
					if (P.hasData(e) && (o = P.access(e), a = P.set(t, o), c = o.events))
							for (i in delete a.handle, a.events = {}, c)
									for (n = 0, r = c[i].length; r > n; n++) d.event.add(t, i, c[i][n]);
					$.hasData(e) && (s = $.access(e), u = d.extend({}, s), $.set(t, u))
			}
	}

	function pe(e, t) {
			var n = e.getElementsByTagName ? e.getElementsByTagName(t || "*") : e.querySelectorAll ? e.querySelectorAll(t || "*") : [];
			return void 0 === t || t && d.nodeName(e, t) ? d.merge([e], n) : n
	}

	function de(e, t) {
			var n = t.nodeName.toLowerCase();
			"input" === n && B.test(e.type) ? t.checked = e.checked : ("input" === n || "textarea" === n) && (t.defaultValue = e.defaultValue)
	}
	ae.optgroup = ae.option, ae.tbody = ae.tfoot = ae.colgroup = ae.caption = ae.thead, ae.th = ae.td, d.extend({
			clone: function(e, t, n) {
					var r, i, o, a, s = e.cloneNode(!0),
							u = d.contains(e.ownerDocument, e);
					if (!(l.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || d.isXMLDoc(e)))
							for (a = pe(s), r = 0, i = (o = pe(e)).length; i > r; r++) de(o[r], a[r]);
					if (t)
							if (n)
									for (o = o || pe(e), a = a || pe(s), r = 0, i = o.length; i > r; r++) fe(o[r], a[r]);
							else fe(e, s);
					return (a = pe(s, "script")).length > 0 && le(a, !u && pe(e, "script")), s
			},
			buildFragment: function(e, t, n, r) {
					for (var i, o, a, s, u, c, l = t.createDocumentFragment(), f = [], p = 0, h = e.length; h > p; p++)
							if ((i = e[p]) || 0 === i)
									if ("object" === d.type(i)) d.merge(f, i.nodeType ? [i] : i);
									else if (ee.test(i)) {
							for (o = o || l.appendChild(t.createElement("div")), a = (Z.exec(i) || ["", ""])[1].toLowerCase(), s = ae[a] || ae._default, o.innerHTML = s[1] + i.replace(J, "<$1></$2>") + s[2], c = s[0]; c--;) o = o.lastChild;
							d.merge(f, o.childNodes), (o = l.firstChild).textContent = ""
					} else f.push(t.createTextNode(i));
					for (l.textContent = "", p = 0; i = f[p++];)
							if ((!r || -1 === d.inArray(i, r)) && (u = d.contains(i.ownerDocument, i), o = pe(l.appendChild(i), "script"), u && le(o), n))
									for (c = 0; i = o[c++];) re.test(i.type || "") && n.push(i);
					return l
			},
			cleanData: function(e) {
					for (var t, n, r, i, o = d.event.special, a = 0; void 0 !== (n = e[a]); a++) {
							if (d.acceptData(n) && ((i = n[P.expando]) && (t = P.cache[i]))) {
									if (t.events)
											for (r in t.events) o[r] ? d.event.remove(n, r) : d.removeEvent(n, r, t.handle);
									P.cache[i] && delete P.cache[i]
							}
							delete $.cache[n[$.expando]]
					}
			}
	}), d.fn.extend({
			text: function(e) {
					return q(this, function(e) {
							return void 0 === e ? d.text(this) : this.empty().each(function() {
									(1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) && (this.textContent = e)
							})
					}, null, e, arguments.length)
			},
			append: function() {
					return this.domManip(arguments, function(e) {
							1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || se(this, e).appendChild(e)
					})
			},
			prepend: function() {
					return this.domManip(arguments, function(e) {
							if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
									var t = se(this, e);
									t.insertBefore(e, t.firstChild)
							}
					})
			},
			before: function() {
					return this.domManip(arguments, function(e) {
							this.parentNode && this.parentNode.insertBefore(e, this)
					})
			},
			after: function() {
					return this.domManip(arguments, function(e) {
							this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
					})
			},
			remove: function(e, t) {
					for (var n, r = e ? d.filter(e, this) : this, i = 0; null != (n = r[i]); i++) t || 1 !== n.nodeType || d.cleanData(pe(n)), n.parentNode && (t && d.contains(n.ownerDocument, n) && le(pe(n, "script")), n.parentNode.removeChild(n));
					return this
			},
			empty: function() {
					for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (d.cleanData(pe(e, !1)), e.textContent = "");
					return this
			},
			clone: function(e, t) {
					return e = null != e && e, t = null == t ? e : t, this.map(function() {
							return d.clone(this, e, t)
					})
			},
			html: function(e) {
					return q(this, function(e) {
							var t = this[0] || {},
									n = 0,
									r = this.length;
							if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
							if ("string" == typeof e && !te.test(e) && !ae[(Z.exec(e) || ["", ""])[1].toLowerCase()]) {
									e = e.replace(J, "<$1></$2>");
									try {
											for (; r > n; n++) 1 === (t = this[n] || {}).nodeType && (d.cleanData(pe(t, !1)), t.innerHTML = e);
											t = 0
									} catch (e) {}
							}
							t && this.empty().append(e)
					}, null, e, arguments.length)
			},
			replaceWith: function() {
					var e = arguments[0];
					return this.domManip(arguments, function(t) {
							e = this.parentNode, d.cleanData(pe(this)), e && e.replaceChild(t, this)
					}), e && (e.length || e.nodeType) ? this : this.remove()
			},
			detach: function(e) {
					return this.remove(e, !0)
			},
			domManip: function(e, t) {
					e = i.apply([], e);
					var n, r, o, a, s, u, c = 0,
							f = this.length,
							p = this,
							h = f - 1,
							m = e[0],
							g = d.isFunction(m);
					if (g || f > 1 && "string" == typeof m && !l.checkClone && ne.test(m)) return this.each(function(n) {
							var r = p.eq(n);
							g && (e[0] = m.call(this, n, r.html())), r.domManip(e, t)
					});
					if (f && (r = (n = d.buildFragment(e, this[0].ownerDocument, !1, this)).firstChild, 1 === n.childNodes.length && (n = r), r)) {
							for (a = (o = d.map(pe(n, "script"), ue)).length; f > c; c++) s = n, c !== h && (s = d.clone(s, !0, !0), a && d.merge(o, pe(s, "script"))), t.call(this[c], s, c);
							if (a)
									for (u = o[o.length - 1].ownerDocument, d.map(o, ce), c = 0; a > c; c++) s = o[c], re.test(s.type || "") && !P.access(s, "globalEval") && d.contains(u, s) && (s.src ? d._evalUrl && d._evalUrl(s.src) : d.globalEval(s.textContent.replace(oe, "")))
					}
					return this
			}
	}), d.each({
			appendTo: "append",
			prependTo: "prepend",
			insertBefore: "before",
			insertAfter: "after",
			replaceAll: "replaceWith"
	}, function(e, t) {
			d.fn[e] = function(e) {
					for (var n, r = [], i = d(e), a = i.length - 1, s = 0; a >= s; s++) n = s === a ? this : this.clone(!0), d(i[s])[t](n), o.apply(r, n.get());
					return this.pushStack(r)
			}
	});
	var he, me = {};

	function ge(t, n) {
			var r, i = d(n.createElement(t)).appendTo(n.body),
					o = e.getDefaultComputedStyle && (r = e.getDefaultComputedStyle(i[0])) ? r.display : d.css(i[0], "display");
			return i.detach(), o
	}

	function ve(e) {
			var t = f,
					n = me[e];
			return n || ("none" !== (n = ge(e, t)) && n || ((t = (he = (he || d("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement))[0].contentDocument).write(), t.close(), n = ge(e, t), he.detach()), me[e] = n), n
	}
	var ye = /^margin/,
			xe = new RegExp("^(" + _ + ")(?!px)[a-z%]+$", "i"),
			be = function(t) {
					return t.ownerDocument.defaultView.opener ? t.ownerDocument.defaultView.getComputedStyle(t, null) : e.getComputedStyle(t, null)
			};

	function we(e, t, n) {
			var r, i, o, a, s = e.style;
			return (n = n || be(e)) && (a = n.getPropertyValue(t) || n[t]), n && ("" !== a || d.contains(e.ownerDocument, e) || (a = d.style(e, t)), xe.test(a) && ye.test(t) && (r = s.width, i = s.minWidth, o = s.maxWidth, s.minWidth = s.maxWidth = s.width = a, a = n.width, s.width = r, s.minWidth = i, s.maxWidth = o)), void 0 !== a ? a + "" : a
	}

	function Ce(e, t) {
			return {
					get: function() {
							return e() ? void delete this.get : (this.get = t).apply(this, arguments)
					}
			}
	}! function() {
			var t, n, r = f.documentElement,
					i = f.createElement("div"),
					o = f.createElement("div");
			if (o.style) {
					function a() {
							o.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute", o.innerHTML = "", r.appendChild(i);
							var a = e.getComputedStyle(o, null);
							t = "1%" !== a.top, n = "4px" === a.width, r.removeChild(i)
					}
					o.style.backgroundClip = "content-box", o.cloneNode(!0).style.backgroundClip = "", l.clearCloneStyle = "content-box" === o.style.backgroundClip, i.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;position:absolute", i.appendChild(o), e.getComputedStyle && d.extend(l, {
							pixelPosition: function() {
									return a(), t
							},
							boxSizingReliable: function() {
									return null == n && a(), n
							},
							reliableMarginRight: function() {
									var t, n = o.appendChild(f.createElement("div"));
									return n.style.cssText = o.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", n.style.marginRight = n.style.width = "0", o.style.width = "1px", r.appendChild(i), t = !parseFloat(e.getComputedStyle(n, null).marginRight), r.removeChild(i), o.removeChild(n), t
							}
					})
			}
	}(), d.swap = function(e, t, n, r) {
			var i, o, a = {};
			for (o in t) a[o] = e.style[o], e.style[o] = t[o];
			for (o in i = n.apply(e, r || []), t) e.style[o] = a[o];
			return i
	};
	var Te = /^(none|table(?!-c[ea]).+)/,
			ke = new RegExp("^(" + _ + ")(.*)$", "i"),
			Ne = new RegExp("^([+-])=(" + _ + ")", "i"),
			Ee = {
					position: "absolute",
					visibility: "hidden",
					display: "block"
			},
			Se = {
					letterSpacing: "0",
					fontWeight: "400"
			},
			je = ["Webkit", "O", "Moz", "ms"];

	function Ae(e, t) {
			if (t in e) return t;
			for (var n = t[0].toUpperCase() + t.slice(1), r = t, i = je.length; i--;)
					if ((t = je[i] + n) in e) return t;
			return r
	}

	function De(e, t, n) {
			var r = ke.exec(t);
			return r ? Math.max(0, r[1] - (n || 0)) + (r[2] || "px") : t
	}

	function Le(e, t, n, r, i) {
			for (var o = n === (r ? "border" : "content") ? 4 : "width" === t ? 1 : 0, a = 0; 4 > o; o += 2) "margin" === n && (a += d.css(e, n + M[o], !0, i)), r ? ("content" === n && (a -= d.css(e, "padding" + M[o], !0, i)), "margin" !== n && (a -= d.css(e, "border" + M[o] + "Width", !0, i))) : (a += d.css(e, "padding" + M[o], !0, i), "padding" !== n && (a += d.css(e, "border" + M[o] + "Width", !0, i)));
			return a
	}

	function He(e, t, n) {
			var r = !0,
					i = "width" === t ? e.offsetWidth : e.offsetHeight,
					o = be(e),
					a = "border-box" === d.css(e, "boxSizing", !1, o);
			if (0 >= i || null == i) {
					if ((0 > (i = we(e, t, o)) || null == i) && (i = e.style[t]), xe.test(i)) return i;
					r = a && (l.boxSizingReliable() || i === e.style[t]), i = parseFloat(i) || 0
			}
			return i + Le(e, t, n || (a ? "border" : "content"), r, o) + "px"
	}

	function qe(e, t) {
			for (var n, r, i, o = [], a = 0, s = e.length; s > a; a++)(r = e[a]).style && (o[a] = P.get(r, "olddisplay"), n = r.style.display, t ? (o[a] || "none" !== n || (r.style.display = ""), "" === r.style.display && W(r) && (o[a] = P.access(r, "olddisplay", ve(r.nodeName)))) : (i = W(r), "none" === n && i || P.set(r, "olddisplay", i ? n : d.css(r, "display"))));
			for (a = 0; s > a; a++)(r = e[a]).style && (t && "none" !== r.style.display && "" !== r.style.display || (r.style.display = t ? o[a] || "" : "none"));
			return e
	}

	function Oe(e, t, n, r, i) {
			return new Oe.prototype.init(e, t, n, r, i)
	}
	d.extend({
			cssHooks: {
					opacity: {
							get: function(e, t) {
									if (t) {
											var n = we(e, "opacity");
											return "" === n ? "1" : n
									}
							}
					}
			},
			cssNumber: {
					columnCount: !0,
					fillOpacity: !0,
					flexGrow: !0,
					flexShrink: !0,
					fontWeight: !0,
					lineHeight: !0,
					opacity: !0,
					order: !0,
					orphans: !0,
					widows: !0,
					zIndex: !0,
					zoom: !0
			},
			cssProps: {
					float: "cssFloat"
			},
			style: function(e, t, n, r) {
					if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
							var i, o, a, s = d.camelCase(t),
									u = e.style;
							return t = d.cssProps[s] || (d.cssProps[s] = Ae(u, s)), a = d.cssHooks[t] || d.cssHooks[s], void 0 === n ? a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : u[t] : ("string" === (o = typeof n) && (i = Ne.exec(n)) && (n = (i[1] + 1) * i[2] + parseFloat(d.css(e, t)), o = "number"), void(null != n && n == n && ("number" !== o || d.cssNumber[s] || (n += "px"), l.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (u[t] = "inherit"), a && "set" in a && void 0 === (n = a.set(e, n, r)) || (u[t] = n))))
					}
			},
			css: function(e, t, n, r) {
					var i, o, a, s = d.camelCase(t);
					return t = d.cssProps[s] || (d.cssProps[s] = Ae(e.style, s)), (a = d.cssHooks[t] || d.cssHooks[s]) && "get" in a && (i = a.get(e, !0, n)), void 0 === i && (i = we(e, t, r)), "normal" === i && t in Se && (i = Se[t]), "" === n || n ? (o = parseFloat(i), !0 === n || d.isNumeric(o) ? o || 0 : i) : i
			}
	}), d.each(["height", "width"], function(e, t) {
			d.cssHooks[t] = {
					get: function(e, n, r) {
							return n ? Te.test(d.css(e, "display")) && 0 === e.offsetWidth ? d.swap(e, Ee, function() {
									return He(e, t, r)
							}) : He(e, t, r) : void 0
					},
					set: function(e, n, r) {
							var i = r && be(e);
							return De(0, n, r ? Le(e, t, r, "border-box" === d.css(e, "boxSizing", !1, i), i) : 0)
					}
			}
	}), d.cssHooks.marginRight = Ce(l.reliableMarginRight, function(e, t) {
			return t ? d.swap(e, {
					display: "inline-block"
			}, we, [e, "marginRight"]) : void 0
	}), d.each({
			margin: "",
			padding: "",
			border: "Width"
	}, function(e, t) {
			d.cssHooks[e + t] = {
					expand: function(n) {
							for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; 4 > r; r++) i[e + M[r] + t] = o[r] || o[r - 2] || o[0];
							return i
					}
			}, ye.test(e) || (d.cssHooks[e + t].set = De)
	}), d.fn.extend({
			css: function(e, t) {
					return q(this, function(e, t, n) {
							var r, i, o = {},
									a = 0;
							if (d.isArray(t)) {
									for (r = be(e), i = t.length; i > a; a++) o[t[a]] = d.css(e, t[a], !1, r);
									return o
							}
							return void 0 !== n ? d.style(e, t, n) : d.css(e, t)
					}, e, t, arguments.length > 1)
			},
			show: function() {
					return qe(this, !0)
			},
			hide: function() {
					return qe(this)
			},
			toggle: function(e) {
					return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
							W(this) ? d(this).show() : d(this).hide()
					})
			}
	}), d.Tween = Oe, Oe.prototype = {
			constructor: Oe,
			init: function(e, t, n, r, i, o) {
					this.elem = e, this.prop = n, this.easing = i || "swing", this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = o || (d.cssNumber[n] ? "" : "px")
			},
			cur: function() {
					var e = Oe.propHooks[this.prop];
					return e && e.get ? e.get(this) : Oe.propHooks._default.get(this)
			},
			run: function(e) {
					var t, n = Oe.propHooks[this.prop];
					return this.options.duration ? this.pos = t = d.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : Oe.propHooks._default.set(this), this
			}
	}, Oe.prototype.init.prototype = Oe.prototype, Oe.propHooks = {
			_default: {
					get: function(e) {
							var t;
							return null == e.elem[e.prop] || e.elem.style && null != e.elem.style[e.prop] ? (t = d.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0 : e.elem[e.prop]
					},
					set: function(e) {
							d.fx.step[e.prop] ? d.fx.step[e.prop](e) : e.elem.style && (null != e.elem.style[d.cssProps[e.prop]] || d.cssHooks[e.prop]) ? d.style(e.elem, e.prop, e.now + e.unit) : e.elem[e.prop] = e.now
					}
			}
	}, Oe.propHooks.scrollTop = Oe.propHooks.scrollLeft = {
			set: function(e) {
					e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
			}
	}, d.easing = {
			linear: function(e) {
					return e
			},
			swing: function(e) {
					return .5 - Math.cos(e * Math.PI) / 2
			}
	}, d.fx = Oe.prototype.init, d.fx.step = {};
	var Pe, $e, Fe = /^(?:toggle|show|hide)$/,
			Re = new RegExp("^(?:([+-])=|)(" + _ + ")([a-z%]*)$", "i"),
			Ie = /queueHooks$/,
			_e = [function(e, t, n) {
					var r, i, o, a, s, u, c, l = this,
							f = {},
							p = e.style,
							h = e.nodeType && W(e),
							m = P.get(e, "fxshow");
					for (r in n.queue || (null == (s = d._queueHooks(e, "fx")).unqueued && (s.unqueued = 0, u = s.empty.fire, s.empty.fire = function() {
									s.unqueued || u()
							}), s.unqueued++, l.always(function() {
									l.always(function() {
											s.unqueued--, d.queue(e, "fx").length || s.empty.fire()
									})
							})), 1 === e.nodeType && ("height" in t || "width" in t) && (n.overflow = [p.overflow, p.overflowX, p.overflowY], c = d.css(e, "display"), "inline" === ("none" === c ? P.get(e, "olddisplay") || ve(e.nodeName) : c) && "none" === d.css(e, "float") && (p.display = "inline-block")), n.overflow && (p.overflow = "hidden", l.always(function() {
									p.overflow = n.overflow[0], p.overflowX = n.overflow[1], p.overflowY = n.overflow[2]
							})), t)
							if (i = t[r], Fe.exec(i)) {
									if (delete t[r], o = o || "toggle" === i, i === (h ? "hide" : "show")) {
											if ("show" !== i || !m || void 0 === m[r]) continue;
											h = !0
									}
									f[r] = m && m[r] || d.style(e, r)
							} else c = void 0;
					if (d.isEmptyObject(f)) "inline" === ("none" === c ? ve(e.nodeName) : c) && (p.display = c);
					else
							for (r in m ? "hidden" in m && (h = m.hidden) : m = P.access(e, "fxshow", {}), o && (m.hidden = !h), h ? d(e).show() : l.done(function() {
											d(e).hide()
									}), l.done(function() {
											var t;
											for (t in P.remove(e, "fxshow"), f) d.style(e, t, f[t])
									}), f) a = Ue(h ? m[r] : 0, r, l), r in m || (m[r] = a.start, h && (a.end = a.start, a.start = "width" === r || "height" === r ? 1 : 0))
			}],
			Me = {
					"*": [function(e, t) {
							var n = this.createTween(e, t),
									r = n.cur(),
									i = Re.exec(t),
									o = i && i[3] || (d.cssNumber[e] ? "" : "px"),
									a = (d.cssNumber[e] || "px" !== o && +r) && Re.exec(d.css(n.elem, e)),
									s = 1,
									u = 20;
							if (a && a[3] !== o) {
									o = o || a[3], i = i || [], a = +r || 1;
									do {
											a /= s = s || ".5", d.style(n.elem, e, a + o)
									} while (s !== (s = n.cur() / r) && 1 !== s && --u)
							}
							return i && (a = n.start = +a || +r || 0, n.unit = o, n.end = i[1] ? a + (i[1] + 1) * i[2] : +i[2]), n
					}]
			};

	function We() {
			return setTimeout(function() {
					Pe = void 0
			}), Pe = d.now()
	}

	function Be(e, t) {
			var n, r = 0,
					i = {
							height: e
					};
			for (t = t ? 1 : 0; 4 > r; r += 2 - t) i["margin" + (n = M[r])] = i["padding" + n] = e;
			return t && (i.opacity = i.width = e), i
	}

	function Ue(e, t, n) {
			for (var r, i = (Me[t] || []).concat(Me["*"]), o = 0, a = i.length; a > o; o++)
					if (r = i[o].call(n, t, e)) return r
	}

	function Ge(e, t, n) {
			var r, i, o = 0,
					a = _e.length,
					s = d.Deferred().always(function() {
							delete u.elem
					}),
					u = function() {
							if (i) return !1;
							for (var t = Pe || We(), n = Math.max(0, c.startTime + c.duration - t), r = 1 - (n / c.duration || 0), o = 0, a = c.tweens.length; a > o; o++) c.tweens[o].run(r);
							return s.notifyWith(e, [c, r, n]), 1 > r && a ? n : (s.resolveWith(e, [c]), !1)
					},
					c = s.promise({
							elem: e,
							props: d.extend({}, t),
							opts: d.extend(!0, {
									specialEasing: {}
							}, n),
							originalProperties: t,
							originalOptions: n,
							startTime: Pe || We(),
							duration: n.duration,
							tweens: [],
							createTween: function(t, n) {
									var r = d.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
									return c.tweens.push(r), r
							},
							stop: function(t) {
									var n = 0,
											r = t ? c.tweens.length : 0;
									if (i) return this;
									for (i = !0; r > n; n++) c.tweens[n].run(1);
									return t ? s.resolveWith(e, [c, t]) : s.rejectWith(e, [c, t]), this
							}
					}),
					l = c.props;
			for (function(e, t) {
							var n, r, i, o, a;
							for (n in e)
									if (i = t[r = d.camelCase(n)], o = e[n], d.isArray(o) && (i = o[1], o = e[n] = o[0]), n !== r && (e[r] = o, delete e[n]), (a = d.cssHooks[r]) && "expand" in a)
											for (n in o = a.expand(o), delete e[r], o) n in e || (e[n] = o[n], t[n] = i);
									else t[r] = i
					}(l, c.opts.specialEasing); a > o; o++)
					if (r = _e[o].call(c, e, l, c.opts)) return r;
			return d.map(l, Ue, c), d.isFunction(c.opts.start) && c.opts.start.call(e, c), d.fx.timer(d.extend(u, {
					elem: e,
					anim: c,
					queue: c.opts.queue
			})), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always)
	}
	d.Animation = d.extend(Ge, {
					tweener: function(e, t) {
							d.isFunction(e) ? (t = e, e = ["*"]) : e = e.split(" ");
							for (var n, r = 0, i = e.length; i > r; r++) n = e[r], Me[n] = Me[n] || [], Me[n].unshift(t)
					},
					prefilter: function(e, t) {
							t ? _e.unshift(e) : _e.push(e)
					}
			}), d.speed = function(e, t, n) {
					var r = e && "object" == typeof e ? d.extend({}, e) : {
							complete: n || !n && t || d.isFunction(e) && e,
							duration: e,
							easing: n && t || t && !d.isFunction(t) && t
					};
					return r.duration = d.fx.off ? 0 : "number" == typeof r.duration ? r.duration : r.duration in d.fx.speeds ? d.fx.speeds[r.duration] : d.fx.speeds._default, (null == r.queue || !0 === r.queue) && (r.queue = "fx"), r.old = r.complete, r.complete = function() {
							d.isFunction(r.old) && r.old.call(this), r.queue && d.dequeue(this, r.queue)
					}, r
			}, d.fn.extend({
					fadeTo: function(e, t, n, r) {
							return this.filter(W).css("opacity", 0).show().end().animate({
									opacity: t
							}, e, n, r)
					},
					animate: function(e, t, n, r) {
							var i = d.isEmptyObject(e),
									o = d.speed(t, n, r),
									a = function() {
											var t = Ge(this, d.extend({}, e), o);
											(i || P.get(this, "finish")) && t.stop(!0)
									};
							return a.finish = a, i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
					},
					stop: function(e, t, n) {
							var r = function(e) {
									var t = e.stop;
									delete e.stop, t(n)
							};
							return "string" != typeof e && (n = t, t = e, e = void 0), t && !1 !== e && this.queue(e || "fx", []), this.each(function() {
									var t = !0,
											i = null != e && e + "queueHooks",
											o = d.timers,
											a = P.get(this);
									if (i) a[i] && a[i].stop && r(a[i]);
									else
											for (i in a) a[i] && a[i].stop && Ie.test(i) && r(a[i]);
									for (i = o.length; i--;) o[i].elem !== this || null != e && o[i].queue !== e || (o[i].anim.stop(n), t = !1, o.splice(i, 1));
									(t || !n) && d.dequeue(this, e)
							})
					},
					finish: function(e) {
							return !1 !== e && (e = e || "fx"), this.each(function() {
									var t, n = P.get(this),
											r = n[e + "queue"],
											i = n[e + "queueHooks"],
											o = d.timers,
											a = r ? r.length : 0;
									for (n.finish = !0, d.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = o.length; t--;) o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
									for (t = 0; a > t; t++) r[t] && r[t].finish && r[t].finish.call(this);
									delete n.finish
							})
					}
			}), d.each(["toggle", "show", "hide"], function(e, t) {
					var n = d.fn[t];
					d.fn[t] = function(e, r, i) {
							return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(Be(t, !0), e, r, i)
					}
			}), d.each({
					slideDown: Be("show"),
					slideUp: Be("hide"),
					slideToggle: Be("toggle"),
					fadeIn: {
							opacity: "show"
					},
					fadeOut: {
							opacity: "hide"
					},
					fadeToggle: {
							opacity: "toggle"
					}
			}, function(e, t) {
					d.fn[e] = function(e, n, r) {
							return this.animate(t, e, n, r)
					}
			}), d.timers = [], d.fx.tick = function() {
					var e, t = 0,
							n = d.timers;
					for (Pe = d.now(); t < n.length; t++)(e = n[t])() || n[t] !== e || n.splice(t--, 1);
					n.length || d.fx.stop(), Pe = void 0
			}, d.fx.timer = function(e) {
					d.timers.push(e), e() ? d.fx.start() : d.timers.pop()
			}, d.fx.interval = 13, d.fx.start = function() {
					$e || ($e = setInterval(d.fx.tick, d.fx.interval))
			}, d.fx.stop = function() {
					clearInterval($e), $e = null
			}, d.fx.speeds = {
					slow: 600,
					fast: 200,
					_default: 400
			}, d.fn.delay = function(e, t) {
					return e = d.fx && d.fx.speeds[e] || e, t = t || "fx", this.queue(t, function(t, n) {
							var r = setTimeout(t, e);
							n.stop = function() {
									clearTimeout(r)
							}
					})
			},
			function() {
					var e = f.createElement("input"),
							t = f.createElement("select"),
							n = t.appendChild(f.createElement("option"));
					e.type = "checkbox", l.checkOn = "" !== e.value, l.optSelected = n.selected, t.disabled = !0, l.optDisabled = !n.disabled, (e = f.createElement("input")).value = "t", e.type = "radio", l.radioValue = "t" === e.value
			}();
	var Xe, ze = d.expr.attrHandle;
	d.fn.extend({
			attr: function(e, t) {
					return q(this, d.attr, e, t, arguments.length > 1)
			},
			removeAttr: function(e) {
					return this.each(function() {
							d.removeAttr(this, e)
					})
			}
	}), d.extend({
			attr: function(e, t, n) {
					var r, i, o = e.nodeType;
					if (e && 3 !== o && 8 !== o && 2 !== o) return typeof e.getAttribute === U ? d.prop(e, t, n) : (1 === o && d.isXMLDoc(e) || (t = t.toLowerCase(), r = d.attrHooks[t] || (d.expr.match.bool.test(t) ? Xe : void 0)), void 0 === n ? r && "get" in r && null !== (i = r.get(e, t)) ? i : null == (i = d.find.attr(e, t)) ? void 0 : i : null !== n ? r && "set" in r && void 0 !== (i = r.set(e, n, t)) ? i : (e.setAttribute(t, n + ""), n) : void d.removeAttr(e, t))
			},
			removeAttr: function(e, t) {
					var n, r, i = 0,
							o = t && t.match(D);
					if (o && 1 === e.nodeType)
							for (; n = o[i++];) r = d.propFix[n] || n, d.expr.match.bool.test(n) && (e[r] = !1), e.removeAttribute(n)
			},
			attrHooks: {
					type: {
							set: function(e, t) {
									if (!l.radioValue && "radio" === t && d.nodeName(e, "input")) {
											var n = e.value;
											return e.setAttribute("type", t), n && (e.value = n), t
									}
							}
					}
			}
	}), Xe = {
			set: function(e, t, n) {
					return !1 === t ? d.removeAttr(e, n) : e.setAttribute(n, n), n
			}
	}, d.each(d.expr.match.bool.source.match(/\w+/g), function(e, t) {
			var n = ze[t] || d.find.attr;
			ze[t] = function(e, t, r) {
					var i, o;
					return r || (o = ze[t], ze[t] = i, i = null != n(e, t, r) ? t.toLowerCase() : null, ze[t] = o), i
			}
	});
	var Qe = /^(?:input|select|textarea|button)$/i;
	d.fn.extend({
			prop: function(e, t) {
					return q(this, d.prop, e, t, arguments.length > 1)
			},
			removeProp: function(e) {
					return this.each(function() {
							delete this[d.propFix[e] || e]
					})
			}
	}), d.extend({
			propFix: {
					for: "htmlFor",
					class: "className"
			},
			prop: function(e, t, n) {
					var r, i, o = e.nodeType;
					if (e && 3 !== o && 8 !== o && 2 !== o) return (1 !== o || !d.isXMLDoc(e)) && (t = d.propFix[t] || t, i = d.propHooks[t]), void 0 !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t]
			},
			propHooks: {
					tabIndex: {
							get: function(e) {
									return e.hasAttribute("tabindex") || Qe.test(e.nodeName) || e.href ? e.tabIndex : -1
							}
					}
			}
	}), l.optSelected || (d.propHooks.selected = {
			get: function(e) {
					var t = e.parentNode;
					return t && t.parentNode && t.parentNode.selectedIndex, null
			}
	}), d.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
			d.propFix[this.toLowerCase()] = this
	});
	var Ye = /[\t\r\n\f]/g;
	d.fn.extend({
			addClass: function(e) {
					var t, n, r, i, o, a, s = "string" == typeof e && e,
							u = 0,
							c = this.length;
					if (d.isFunction(e)) return this.each(function(t) {
							d(this).addClass(e.call(this, t, this.className))
					});
					if (s)
							for (t = (e || "").match(D) || []; c > u; u++)
									if (r = 1 === (n = this[u]).nodeType && (n.className ? (" " + n.className + " ").replace(Ye, " ") : " ")) {
											for (o = 0; i = t[o++];) r.indexOf(" " + i + " ") < 0 && (r += i + " ");
											a = d.trim(r), n.className !== a && (n.className = a)
									}
					return this
			},
			removeClass: function(e) {
					var t, n, r, i, o, a, s = 0 === arguments.length || "string" == typeof e && e,
							u = 0,
							c = this.length;
					if (d.isFunction(e)) return this.each(function(t) {
							d(this).removeClass(e.call(this, t, this.className))
					});
					if (s)
							for (t = (e || "").match(D) || []; c > u; u++)
									if (r = 1 === (n = this[u]).nodeType && (n.className ? (" " + n.className + " ").replace(Ye, " ") : "")) {
											for (o = 0; i = t[o++];)
													for (; r.indexOf(" " + i + " ") >= 0;) r = r.replace(" " + i + " ", " ");
											a = e ? d.trim(r) : "", n.className !== a && (n.className = a)
									}
					return this
			},
			toggleClass: function(e, t) {
					var n = typeof e;
					return "boolean" == typeof t && "string" === n ? t ? this.addClass(e) : this.removeClass(e) : this.each(d.isFunction(e) ? function(n) {
							d(this).toggleClass(e.call(this, n, this.className, t), t)
					} : function() {
							if ("string" === n)
									for (var t, r = 0, i = d(this), o = e.match(D) || []; t = o[r++];) i.hasClass(t) ? i.removeClass(t) : i.addClass(t);
							else(n === U || "boolean" === n) && (this.className && P.set(this, "__className__", this.className), this.className = this.className || !1 === e ? "" : P.get(this, "__className__") || "")
					})
			},
			hasClass: function(e) {
					for (var t = " " + e + " ", n = 0, r = this.length; r > n; n++)
							if (1 === this[n].nodeType && (" " + this[n].className + " ").replace(Ye, " ").indexOf(t) >= 0) return !0;
					return !1
			}
	});
	var Ve = /\r/g;
	d.fn.extend({
			val: function(e) {
					var t, n, r, i = this[0];
					return arguments.length ? (r = d.isFunction(e), this.each(function(n) {
							var i;
							1 === this.nodeType && (null == (i = r ? e.call(this, n, d(this).val()) : e) ? i = "" : "number" == typeof i ? i += "" : d.isArray(i) && (i = d.map(i, function(e) {
									return null == e ? "" : e + ""
							})), (t = d.valHooks[this.type] || d.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, i, "value") || (this.value = i))
					})) : i ? (t = d.valHooks[i.type] || d.valHooks[i.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(i, "value")) ? n : "string" == typeof(n = i.value) ? n.replace(Ve, "") : null == n ? "" : n : void 0
			}
	}), d.extend({
			valHooks: {
					option: {
							get: function(e) {
									var t = d.find.attr(e, "value");
									return null != t ? t : d.trim(d.text(e))
							}
					},
					select: {
							get: function(e) {
									for (var t, n, r = e.options, i = e.selectedIndex, o = "select-one" === e.type || 0 > i, a = o ? null : [], s = o ? i + 1 : r.length, u = 0 > i ? s : o ? i : 0; s > u; u++)
											if (!(!(n = r[u]).selected && u !== i || (l.optDisabled ? n.disabled : null !== n.getAttribute("disabled")) || n.parentNode.disabled && d.nodeName(n.parentNode, "optgroup"))) {
													if (t = d(n).val(), o) return t;
													a.push(t)
											}
									return a
							},
							set: function(e, t) {
									for (var n, r, i = e.options, o = d.makeArray(t), a = i.length; a--;)((r = i[a]).selected = d.inArray(r.value, o) >= 0) && (n = !0);
									return n || (e.selectedIndex = -1), o
							}
					}
			}
	}), d.each(["radio", "checkbox"], function() {
			d.valHooks[this] = {
					set: function(e, t) {
							return d.isArray(t) ? e.checked = d.inArray(d(e).val(), t) >= 0 : void 0
					}
			}, l.checkOn || (d.valHooks[this].get = function(e) {
					return null === e.getAttribute("value") ? "on" : e.value
			})
	}), d.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(e, t) {
			d.fn[t] = function(e, n) {
					return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
			}
	}), d.fn.extend({
			hover: function(e, t) {
					return this.mouseenter(e).mouseleave(t || e)
			},
			bind: function(e, t, n) {
					return this.on(e, null, t, n)
			},
			unbind: function(e, t) {
					return this.off(e, null, t)
			},
			delegate: function(e, t, n, r) {
					return this.on(t, e, n, r)
			},
			undelegate: function(e, t, n) {
					return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
			}
	});
	var Ke = d.now(),
			Je = /\?/;
	d.parseJSON = function(e) {
			return JSON.parse(e + "")
	}, d.parseXML = function(e) {
			var t;
			if (!e || "string" != typeof e) return null;
			try {
					t = (new DOMParser).parseFromString(e, "text/xml")
			} catch (e) {
					t = void 0
			}
			return (!t || t.getElementsByTagName("parsererror").length) && d.error("Invalid XML: " + e), t
	};
	var Ze = /#.*$/,
			et = /([?&])_=[^&]*/,
			tt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
			nt = /^(?:GET|HEAD)$/,
			rt = /^\/\//,
			it = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
			ot = {},
			at = {},
			st = "*/".concat("*"),
			ut = e.location.href,
			ct = it.exec(ut.toLowerCase()) || [];

	function lt(e) {
			return function(t, n) {
					"string" != typeof t && (n = t, t = "*");
					var r, i = 0,
							o = t.toLowerCase().match(D) || [];
					if (d.isFunction(n))
							for (; r = o[i++];) "+" === r[0] ? (r = r.slice(1) || "*", (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n)
			}
	}

	function ft(e, t, n, r) {
			var i = {},
					o = e === at;

			function a(s) {
					var u;
					return i[s] = !0, d.each(e[s] || [], function(e, s) {
							var c = s(t, n, r);
							return "string" != typeof c || o || i[c] ? o ? !(u = c) : void 0 : (t.dataTypes.unshift(c), a(c), !1)
					}), u
			}
			return a(t.dataTypes[0]) || !i["*"] && a("*")
	}

	function pt(e, t) {
			var n, r, i = d.ajaxSettings.flatOptions || {};
			for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
			return r && d.extend(!0, e, r), e
	}
	d.extend({
			active: 0,
			lastModified: {},
			etag: {},
			ajaxSettings: {
					url: ut,
					type: "GET",
					isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(ct[1]),
					global: !0,
					processData: !0,
					async: !0,
					contentType: "application/x-www-form-urlencoded; charset=UTF-8",
					accepts: {
							"*": st,
							text: "text/plain",
							html: "text/html",
							xml: "application/xml, text/xml",
							json: "application/json, text/javascript"
					},
					contents: {
							xml: /xml/,
							html: /html/,
							json: /json/
					},
					responseFields: {
							xml: "responseXML",
							text: "responseText",
							json: "responseJSON"
					},
					converters: {
							"* text": String,
							"text html": !0,
							"text json": d.parseJSON,
							"text xml": d.parseXML
					},
					flatOptions: {
							url: !0,
							context: !0
					}
			},
			ajaxSetup: function(e, t) {
					return t ? pt(pt(e, d.ajaxSettings), t) : pt(d.ajaxSettings, e)
			},
			ajaxPrefilter: lt(ot),
			ajaxTransport: lt(at),
			ajax: function(e, t) {
					"object" == typeof e && (t = e, e = void 0), t = t || {};
					var n, r, i, o, a, s, u, c, l = d.ajaxSetup({}, t),
							f = l.context || l,
							p = l.context && (f.nodeType || f.jquery) ? d(f) : d.event,
							h = d.Deferred(),
							m = d.Callbacks("once memory"),
							g = l.statusCode || {},
							v = {},
							y = {},
							x = 0,
							b = "canceled",
							w = {
									readyState: 0,
									getResponseHeader: function(e) {
											var t;
											if (2 === x) {
													if (!o)
															for (o = {}; t = tt.exec(i);) o[t[1].toLowerCase()] = t[2];
													t = o[e.toLowerCase()]
											}
											return null == t ? null : t
									},
									getAllResponseHeaders: function() {
											return 2 === x ? i : null
									},
									setRequestHeader: function(e, t) {
											var n = e.toLowerCase();
											return x || (e = y[n] = y[n] || e, v[e] = t), this
									},
									overrideMimeType: function(e) {
											return x || (l.mimeType = e), this
									},
									statusCode: function(e) {
											var t;
											if (e)
													if (2 > x)
															for (t in e) g[t] = [g[t], e[t]];
													else w.always(e[w.status]);
											return this
									},
									abort: function(e) {
											var t = e || b;
											return n && n.abort(t), C(0, t), this
									}
							};
					if (h.promise(w).complete = m.add, w.success = w.done, w.error = w.fail, l.url = ((e || l.url || ut) + "").replace(Ze, "").replace(rt, ct[1] + "//"), l.type = t.method || t.type || l.method || l.type, l.dataTypes = d.trim(l.dataType || "*").toLowerCase().match(D) || [""], null == l.crossDomain && (s = it.exec(l.url.toLowerCase()), l.crossDomain = !(!s || s[1] === ct[1] && s[2] === ct[2] && (s[3] || ("http:" === s[1] ? "80" : "443")) === (ct[3] || ("http:" === ct[1] ? "80" : "443")))), l.data && l.processData && "string" != typeof l.data && (l.data = d.param(l.data, l.traditional)), ft(ot, l, t, w), 2 === x) return w;
					for (c in (u = d.event && l.global) && 0 == d.active++ && d.event.trigger("ajaxStart"), l.type = l.type.toUpperCase(), l.hasContent = !nt.test(l.type), r = l.url, l.hasContent || (l.data && (r = l.url += (Je.test(r) ? "&" : "?") + l.data, delete l.data), !1 === l.cache && (l.url = et.test(r) ? r.replace(et, "$1_=" + Ke++) : r + (Je.test(r) ? "&" : "?") + "_=" + Ke++)), l.ifModified && (d.lastModified[r] && w.setRequestHeader("If-Modified-Since", d.lastModified[r]), d.etag[r] && w.setRequestHeader("If-None-Match", d.etag[r])), (l.data && l.hasContent && !1 !== l.contentType || t.contentType) && w.setRequestHeader("Content-Type", l.contentType), w.setRequestHeader("Accept", l.dataTypes[0] && l.accepts[l.dataTypes[0]] ? l.accepts[l.dataTypes[0]] + ("*" !== l.dataTypes[0] ? ", " + st + "; q=0.01" : "") : l.accepts["*"]), l.headers) w.setRequestHeader(c, l.headers[c]);
					if (l.beforeSend && (!1 === l.beforeSend.call(f, w, l) || 2 === x)) return w.abort();
					for (c in b = "abort", {
									success: 1,
									error: 1,
									complete: 1
							}) w[c](l[c]);
					if (n = ft(at, l, t, w)) {
							w.readyState = 1, u && p.trigger("ajaxSend", [w, l]), l.async && l.timeout > 0 && (a = setTimeout(function() {
									w.abort("timeout")
							}, l.timeout));
							try {
									x = 1, n.send(v, C)
							} catch (e) {
									if (!(2 > x)) throw e;
									C(-1, e)
							}
					} else C(-1, "No Transport");

					function C(e, t, o, s) {
							var c, v, y, b, C, T = t;
							2 !== x && (x = 2, a && clearTimeout(a), n = void 0, i = s || "", w.readyState = e > 0 ? 4 : 0, c = e >= 200 && 300 > e || 304 === e, o && (b = function(e, t, n) {
									for (var r, i, o, a, s = e.contents, u = e.dataTypes;
											"*" === u[0];) u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
									if (r)
											for (i in s)
													if (s[i] && s[i].test(r)) {
															u.unshift(i);
															break
													}
									if (u[0] in n) o = u[0];
									else {
											for (i in n) {
													if (!u[0] || e.converters[i + " " + u[0]]) {
															o = i;
															break
													}
													a || (a = i)
											}
											o = o || a
									}
									return o ? (o !== u[0] && u.unshift(o), n[o]) : void 0
							}(l, w, o)), b = function(e, t, n, r) {
									var i, o, a, s, u, c = {},
											l = e.dataTypes.slice();
									if (l[1])
											for (a in e.converters) c[a.toLowerCase()] = e.converters[a];
									for (o = l.shift(); o;)
											if (e.responseFields[o] && (n[e.responseFields[o]] = t), !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), u = o, o = l.shift())
													if ("*" === o) o = u;
													else if ("*" !== u && u !== o) {
											if (!(a = c[u + " " + o] || c["* " + o]))
													for (i in c)
															if ((s = i.split(" "))[1] === o && (a = c[u + " " + s[0]] || c["* " + s[0]])) {
																	!0 === a ? a = c[i] : !0 !== c[i] && (o = s[0], l.unshift(s[1]));
																	break
															}
											if (!0 !== a)
													if (a && e.throws) t = a(t);
													else try {
															t = a(t)
													} catch (e) {
															return {
																	state: "parsererror",
																	error: a ? e : "No conversion from " + u + " to " + o
															}
													}
									}
									return {
											state: "success",
											data: t
									}
							}(l, b, w, c), c ? (l.ifModified && ((C = w.getResponseHeader("Last-Modified")) && (d.lastModified[r] = C), (C = w.getResponseHeader("etag")) && (d.etag[r] = C)), 204 === e || "HEAD" === l.type ? T = "nocontent" : 304 === e ? T = "notmodified" : (T = b.state, v = b.data, c = !(y = b.error))) : (y = T, (e || !T) && (T = "error", 0 > e && (e = 0))), w.status = e, w.statusText = (t || T) + "", c ? h.resolveWith(f, [v, T, w]) : h.rejectWith(f, [w, T, y]), w.statusCode(g), g = void 0, u && p.trigger(c ? "ajaxSuccess" : "ajaxError", [w, l, c ? v : y]), m.fireWith(f, [w, T]), u && (p.trigger("ajaxComplete", [w, l]), --d.active || d.event.trigger("ajaxStop")))
					}
					return w
			},
			getJSON: function(e, t, n) {
					return d.get(e, t, n, "json")
			},
			getScript: function(e, t) {
					return d.get(e, void 0, t, "script")
			}
	}), d.each(["get", "post"], function(e, t) {
			d[t] = function(e, n, r, i) {
					return d.isFunction(n) && (i = i || r, r = n, n = void 0), d.ajax({
							url: e,
							type: t,
							dataType: i,
							data: n,
							success: r
					})
			}
	}), d._evalUrl = function(e) {
			return d.ajax({
					url: e,
					type: "GET",
					dataType: "script",
					async: !1,
					global: !1,
					throws: !0
			})
	}, d.fn.extend({
			wrapAll: function(e) {
					var t;
					return d.isFunction(e) ? this.each(function(t) {
							d(this).wrapAll(e.call(this, t))
					}) : (this[0] && (t = d(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function() {
							for (var e = this; e.firstElementChild;) e = e.firstElementChild;
							return e
					}).append(this)), this)
			},
			wrapInner: function(e) {
					return this.each(d.isFunction(e) ? function(t) {
							d(this).wrapInner(e.call(this, t))
					} : function() {
							var t = d(this),
									n = t.contents();
							n.length ? n.wrapAll(e) : t.append(e)
					})
			},
			wrap: function(e) {
					var t = d.isFunction(e);
					return this.each(function(n) {
							d(this).wrapAll(t ? e.call(this, n) : e)
					})
			},
			unwrap: function() {
					return this.parent().each(function() {
							d.nodeName(this, "body") || d(this).replaceWith(this.childNodes)
					}).end()
			}
	}), d.expr.filters.hidden = function(e) {
			return e.offsetWidth <= 0 && e.offsetHeight <= 0
	}, d.expr.filters.visible = function(e) {
			return !d.expr.filters.hidden(e)
	};
	var dt = /%20/g,
			ht = /\[\]$/,
			mt = /\r?\n/g,
			gt = /^(?:submit|button|image|reset|file)$/i,
			vt = /^(?:input|select|textarea|keygen)/i;

	function yt(e, t, n, r) {
			var i;
			if (d.isArray(t)) d.each(t, function(t, i) {
					n || ht.test(e) ? r(e, i) : yt(e + "[" + ("object" == typeof i ? t : "") + "]", i, n, r)
			});
			else if (n || "object" !== d.type(t)) r(e, t);
			else
					for (i in t) yt(e + "[" + i + "]", t[i], n, r)
	}
	d.param = function(e, t) {
			var n, r = [],
					i = function(e, t) {
							t = d.isFunction(t) ? t() : null == t ? "" : t, r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t)
					};
			if (void 0 === t && (t = d.ajaxSettings && d.ajaxSettings.traditional), d.isArray(e) || e.jquery && !d.isPlainObject(e)) d.each(e, function() {
					i(this.name, this.value)
			});
			else
					for (n in e) yt(n, e[n], t, i);
			return r.join("&").replace(dt, "+")
	}, d.fn.extend({
			serialize: function() {
					return d.param(this.serializeArray())
			},
			serializeArray: function() {
					return this.map(function() {
							var e = d.prop(this, "elements");
							return e ? d.makeArray(e) : this
					}).filter(function() {
							var e = this.type;
							return this.name && !d(this).is(":disabled") && vt.test(this.nodeName) && !gt.test(e) && (this.checked || !B.test(e))
					}).map(function(e, t) {
							var n = d(this).val();
							return null == n ? null : d.isArray(n) ? d.map(n, function(e) {
									return {
											name: t.name,
											value: e.replace(mt, "\r\n")
									}
							}) : {
									name: t.name,
									value: n.replace(mt, "\r\n")
							}
					}).get()
			}
	}), d.ajaxSettings.xhr = function() {
			try {
					return new XMLHttpRequest
			} catch (e) {}
	};
	var xt = 0,
			bt = {},
			wt = {
					0: 200,
					1223: 204
			},
			Ct = d.ajaxSettings.xhr();
	e.attachEvent && e.attachEvent("onunload", function() {
			for (var e in bt) bt[e]()
	}), l.cors = !!Ct && "withCredentials" in Ct, l.ajax = Ct = !!Ct, d.ajaxTransport(function(e) {
			var t;
			return l.cors || Ct && !e.crossDomain ? {
					send: function(n, r) {
							var i, o = e.xhr(),
									a = ++xt;
							if (o.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
									for (i in e.xhrFields) o[i] = e.xhrFields[i];
							for (i in e.mimeType && o.overrideMimeType && o.overrideMimeType(e.mimeType), e.crossDomain || n["X-Requested-With"] || (n["X-Requested-With"] = "XMLHttpRequest"), n) o.setRequestHeader(i, n[i]);
							t = function(e) {
									return function() {
											t && (delete bt[a], t = o.onload = o.onerror = null, "abort" === e ? o.abort() : "error" === e ? r(o.status, o.statusText) : r(wt[o.status] || o.status, o.statusText, "string" == typeof o.responseText ? {
													text: o.responseText
											} : void 0, o.getAllResponseHeaders()))
									}
							}, o.onload = t(), o.onerror = t("error"), t = bt[a] = t("abort");
							try {
									o.send(e.hasContent && e.data || null)
							} catch (e) {
									if (t) throw e
							}
					},
					abort: function() {
							t && t()
					}
			} : void 0
	}), d.ajaxSetup({
			accepts: {
					script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
			},
			contents: {
					script: /(?:java|ecma)script/
			},
			converters: {
					"text script": function(e) {
							return d.globalEval(e), e
					}
			}
	}), d.ajaxPrefilter("script", function(e) {
			void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET")
	}), d.ajaxTransport("script", function(e) {
			var t, n;
			if (e.crossDomain) return {
					send: function(r, i) {
							t = d("<script>").prop({
									async: !0,
									charset: e.scriptCharset,
									src: e.url
							}).on("load error", n = function(e) {
									t.remove(), n = null, e && i("error" === e.type ? 404 : 200, e.type)
							}), f.head.appendChild(t[0])
					},
					abort: function() {
							n && n()
					}
			}
	});
	var Tt = [],
			kt = /(=)\?(?=&|$)|\?\?/;
	d.ajaxSetup({
			jsonp: "callback",
			jsonpCallback: function() {
					var e = Tt.pop() || d.expando + "_" + Ke++;
					return this[e] = !0, e
			}
	}), d.ajaxPrefilter("json jsonp", function(t, n, r) {
			var i, o, a, s = !1 !== t.jsonp && (kt.test(t.url) ? "url" : "string" == typeof t.data && !(t.contentType || "").indexOf("application/x-www-form-urlencoded") && kt.test(t.data) && "data");
			return s || "jsonp" === t.dataTypes[0] ? (i = t.jsonpCallback = d.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, s ? t[s] = t[s].replace(kt, "$1" + i) : !1 !== t.jsonp && (t.url += (Je.test(t.url) ? "&" : "?") + t.jsonp + "=" + i), t.converters["script json"] = function() {
					return a || d.error(i + " was not called"), a[0]
			}, t.dataTypes[0] = "json", o = e[i], e[i] = function() {
					a = arguments
			}, r.always(function() {
					e[i] = o, t[i] && (t.jsonpCallback = n.jsonpCallback, Tt.push(i)), a && d.isFunction(o) && o(a[0]), a = o = void 0
			}), "script") : void 0
	}), d.parseHTML = function(e, t, n) {
			if (!e || "string" != typeof e) return null;
			"boolean" == typeof t && (n = t, t = !1), t = t || f;
			var r = w.exec(e),
					i = !n && [];
			return r ? [t.createElement(r[1])] : (r = d.buildFragment([e], t, i), i && i.length && d(i).remove(), d.merge([], r.childNodes))
	};
	var Nt = d.fn.load;
	d.fn.load = function(e, t, n) {
			if ("string" != typeof e && Nt) return Nt.apply(this, arguments);
			var r, i, o, a = this,
					s = e.indexOf(" ");
			return s >= 0 && (r = d.trim(e.slice(s)), e = e.slice(0, s)), d.isFunction(t) ? (n = t, t = void 0) : t && "object" == typeof t && (i = "POST"), a.length > 0 && d.ajax({
					url: e,
					type: i,
					dataType: "html",
					data: t
			}).done(function(e) {
					o = arguments, a.html(r ? d("<div>").append(d.parseHTML(e)).find(r) : e)
			}).complete(n && function(e, t) {
					a.each(n, o || [e.responseText, t, e])
			}), this
	}, d.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
			d.fn[t] = function(e) {
					return this.on(t, e)
			}
	}), d.expr.filters.animated = function(e) {
			return d.grep(d.timers, function(t) {
					return e === t.elem
			}).length
	};
	var Et = e.document.documentElement;

	function St(e) {
			return d.isWindow(e) ? e : 9 === e.nodeType && e.defaultView
	}
	d.offset = {
			setOffset: function(e, t, n) {
					var r, i, o, a, s, u, c = d.css(e, "position"),
							l = d(e),
							f = {};
					"static" === c && (e.style.position = "relative"), s = l.offset(), o = d.css(e, "top"), u = d.css(e, "left"), ("absolute" === c || "fixed" === c) && (o + u).indexOf("auto") > -1 ? (a = (r = l.position()).top, i = r.left) : (a = parseFloat(o) || 0, i = parseFloat(u) || 0), d.isFunction(t) && (t = t.call(e, n, s)), null != t.top && (f.top = t.top - s.top + a), null != t.left && (f.left = t.left - s.left + i), "using" in t ? t.using.call(e, f) : l.css(f)
			}
	}, d.fn.extend({
			offset: function(e) {
					if (arguments.length) return void 0 === e ? this : this.each(function(t) {
							d.offset.setOffset(this, e, t)
					});
					var t, n, r = this[0],
							i = {
									top: 0,
									left: 0
							},
							o = r && r.ownerDocument;
					return o ? (t = o.documentElement, d.contains(t, r) ? (typeof r.getBoundingClientRect !== U && (i = r.getBoundingClientRect()), n = St(o), {
							top: i.top + n.pageYOffset - t.clientTop,
							left: i.left + n.pageXOffset - t.clientLeft
					}) : i) : void 0
			},
			position: function() {
					if (this[0]) {
							var e, t, n = this[0],
									r = {
											top: 0,
											left: 0
									};
							return "fixed" === d.css(n, "position") ? t = n.getBoundingClientRect() : (e = this.offsetParent(), t = this.offset(), d.nodeName(e[0], "html") || (r = e.offset()), r.top += d.css(e[0], "borderTopWidth", !0), r.left += d.css(e[0], "borderLeftWidth", !0)), {
									top: t.top - r.top - d.css(n, "marginTop", !0),
									left: t.left - r.left - d.css(n, "marginLeft", !0)
							}
					}
			},
			offsetParent: function() {
					return this.map(function() {
							for (var e = this.offsetParent || Et; e && !d.nodeName(e, "html") && "static" === d.css(e, "position");) e = e.offsetParent;
							return e || Et
					})
			}
	}), d.each({
			scrollLeft: "pageXOffset",
			scrollTop: "pageYOffset"
	}, function(t, n) {
			var r = "pageYOffset" === n;
			d.fn[t] = function(i) {
					return q(this, function(t, i, o) {
							var a = St(t);
							return void 0 === o ? a ? a[n] : t[i] : void(a ? a.scrollTo(r ? e.pageXOffset : o, r ? o : e.pageYOffset) : t[i] = o)
					}, t, i, arguments.length, null)
			}
	}), d.each(["top", "left"], function(e, t) {
			d.cssHooks[t] = Ce(l.pixelPosition, function(e, n) {
					return n ? (n = we(e, t), xe.test(n) ? d(e).position()[t] + "px" : n) : void 0
			})
	}), d.each({
			Height: "height",
			Width: "width"
	}, function(e, t) {
			d.each({
					padding: "inner" + e,
					content: t,
					"": "outer" + e
			}, function(n, r) {
					d.fn[r] = function(r, i) {
							var o = arguments.length && (n || "boolean" != typeof r),
									a = n || (!0 === r || !0 === i ? "margin" : "border");
							return q(this, function(t, n, r) {
									var i;
									return d.isWindow(t) ? t.document.documentElement["client" + e] : 9 === t.nodeType ? (i = t.documentElement, Math.max(t.body["scroll" + e], i["scroll" + e], t.body["offset" + e], i["offset" + e], i["client" + e])) : void 0 === r ? d.css(t, n, a) : d.style(t, n, r, a)
							}, t, o ? r : void 0, o, null)
					}
			})
	}), d.fn.size = function() {
			return this.length
	}, d.fn.andSelf = d.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function() {
			return d
	});
	var jt = e.jQuery,
			At = e.$;
	return d.noConflict = function(t) {
			return e.$ === d && (e.$ = At), t && e.jQuery === d && (e.jQuery = jt), d
	}, typeof t === U && (e.jQuery = e.$ = d), d
}), jQuery(document).ready(function(e) {
	var t = e("input[name=option-2]:checked").val(),
			n = e("input[name=option-2]:checked").data("barcode");
	e("#swatch-name").html(t), e("#swatch-desc").html(n);
	var r = e("input[name=option-2]:checked").data("img");
	e(".slide.slick-slide").each(function() {
			var t = e(this).find("img").attr("src");
			r == t && (console.log("this is default below 1" + r), e(this).trigger("click"))
	}), e(".swatch input").change(function() {
			e("input[name=option-2]").parent().removeClass("active"), e("input[name=option-1]").parent().removeClass("active"), e("input[name=option-0]").parent().removeClass("active"), e("input[name=option-2]:checked").parent().addClass("active"), e("input[name=option-1]:checked").parent().addClass("active"), e("input[name=option-0]:checked").parent().addClass("active");
			var t = e("input[name=option-2]:checked").val(),
					n = e("input[name=option-1]:checked").val(),
					r = (s = e("input[name=option-0]:checked").val()) + " / " + n + " / " + t;
			e("select[name=id]").find("option").each(function() {
					e(this).text() == r && e("select[name=id]").val(e(this).val()).trigger("change")
			});
			var i = e("input[name=option-2]:checked").val();
			e("#swatch-name").html(i);
			var o = e("input[name=option-2]:checked").data("barcode");
			e("#swatch-desc").html(o);
			var a = e("input[name=option-2]:checked").data("img");
			e(".slide.slick-slide").each(function() {
					var t = e(this).find("img").attr("src");
					a == t && e(this).trigger("click")
			});
			t = e(this).parent().find("input[name=option-2]:checked").val(), n = e(this).parent().find("input[name=option-1]:checked").val();
			var s = e(this).parent().find("input[name=option-0]:checked").val(),
					u = e(this).parent().parent().parent().find("#totl-vr").val().split("/"),
					c = (u[0], u[1]),
					l = u[2],
					f = (e(this).val(), s + " /" + c + "/" + l);
			e(this).parent().parent().parent().find("select[name=id]").find("option").each(function() {
					e(this).text() == f && (e("select[name=id]").find("option").removeAttr("selected"), e(this).attr("selected", "selected"), e("select[name=id]").val(e(this).val()).trigger("change"))
			})
	})
}),
toggle_in_stock_message = function() {
  $('.gtr').hide();
  var parent_section = $('select.product-form__master-select').parents('.shopify-section');
  var product = JSON.parse(parent_section.find('[data-product-json]').html());
  var selected_option = $('select.product-form__master-select option:selected');
  var stockvar = parseInt(selected_option.attr('data-stock'));
	var selected_variant = product.variants.filter(variant => variant.id == selected_option[0].value);

  var restock_tag = `NoRestock_${customer_warehouse}_${selected_variant.sku}`;
  var rst = selected_option.attr('data-inplc');
  var arr = rst.split('/');
  parent_section.find('.in-stock-message').hide();

  var product_available = true;
  if (product.tags.includes(restock_tag)) {
    product_available = false;
  }
  if(rst.indexOf('continue') != -1 && product_available){
    var rst = selected_option.text();
    var arr = rst.split(' / ');
    var arrclass = '';

    if(arr == "11"){
      parent_section.find('.der11').css('display', 'block');
      arrclass = '11';
    }
    else if(arr == "11 Pro"){
      parent_section.find('.der11Pro').css('display', 'block');
      arrclass = '11Pro';
    }
    else if(arr == "11 Pro Max"){
      parent_section.find('.der11ProMax').css('display', 'block');
      arrclass = '11ProMax';
    }
    else if(arr == "XR"){
      parent_section.find('.derXR').css('display', 'block');
      arrclass = 'XR';
    }
    else if(arr == "X & XS"){
      parent_section.find('.derX').css('display', 'block');
      arrclass = 'X';
    }
    else if(arr == "XS Max"){
      parent_section.find('.derXSMax').css('display', 'block');
      arrclass = 'XSMax';
    }
    else if(product.title.includes('Airpod')){
      parent_section.find('.derAirpod').css('display', 'block');
      arrclass = 'Airpod';
    }
    else if(product.title.includes('AirTag')){
      parent_section.find('.derAirtag').css('display', 'block');
      arrclass = 'Airtag';
    }
    else{
      if(arr.length > 2) {
        arrclass = arr[0].split('/')[0].replace(/[^a-zA-Z0-9]/g, '').replace(/\s/g, '')+arr[1].replace(/[^a-zA-Z0-9]/g, '').replace(/\s/g, '');
      } else {
        arrclass = arr[0].split('/')[0].replace(/[^a-zA-Z0-9]/g, '').replace(/\s/g, '');
      }
      parent_section.find('.der'+arrclass).css('display', 'block');
    }
    $(".email_signup3").hide();
    $('.add_sub').removeClass('show');
    $('.add_sub').addClass('hide');
    $('.add_cart').removeClass('hide');
    $('.add_cart').addClass('show');
    if(!parent_section.find('.der'+arrclass+' .us'+customer_warehouse).is(':visible')){
      parent_section.find('.in-stock-message').show();
    }
  } else {
    $('.add_cart').removeClass('show');
    $('.add_cart').addClass('hide');
    $(".email_signup3").show();
    $('.add_sub').removeClass('hide');
    $('.add_sub').addClass('show')
  }
}
window.customer_warehouse = '';
/* default  annoucement message */
$.getJSON("https://geolocation-db.com/json/").done(function(e) {
//  console.log(e);
if(e.country_code === "Not found"){
jQuery.get("http://ipinfo.io", function(e) {
 	var country_codes = e.country;
	console.log(country_codes);
	if("US" === country_codes){
		$(".wus.us" + country_codes).css("display", "block"), jQuery(".der38").css("display", "none"),window.customer_warehouse = "US";
		if($('[data-section-type="product-template"]').length) {
      toggle_in_stock_message();
    }
	}

 else if("FR" === country_codes || "RU" === country_codes || "DE" === country_codes || "TR" === country_codes || "IT" === country_codes || "ES" === country_codes || "PL" === country_codes || "UA" === country_codes || "RO" === country_codes || "KZ" === country_codes || "NL" === country_codes || "BE" === country_codes || "GR" === country_codes || "CZ" === country_codes || "SE" === country_codes || "PT" === country_codes || "HU" === country_codes || "BG" === country_codes || "RS" === country_codes || "DK" === country_codes || "FI" === country_codes || "SK" === country_codes || "SI" === country_codes  || "NO" === country_codes || "IE" === country_codes || "HR" === country_codes || "GE" === country_codes || "EE" === country_codes || "LU" === country_codes || "IS" === country_codes || "MT" === country_codes || "CY" === country_codes || "LT" === country_codes || "LV" === country_codes || "AL" === country_codes || "MD" === country_codes || "BA" === country_codes || "AM" === country_codes || "MK" === country_codes || "ME" === country_codes || "XK" === country_codes || "CY" === country_codes || "AZ" === country_codes || "AD" === country_codes || "LI" === country_codes || "MC" === country_codes || "VA" === country_codes){
	$(".wus.usEU").css("display", "block"), jQuery(".der38").css("display", "none");
	window.customer_warehouse = "EU";
	if($('[data-section-type="product-template"]').length) {
    toggle_in_stock_message();
  }
} else {
		$(".wus.usHK").css("display", "block").addClass('country-code');
		window.customer_warehouse = "HK";
		if($('[data-section-type="product-template"]').length) {
	    toggle_in_stock_message();
	  }
	}
    
        /* English T1 GEOs */
  "US" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 6-DAY <strong>US</strong> SHIPPING") :
  "NZ" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 9-DAY SHIPPING IN <strong>NZ</strong>") :
  "AU" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING TO <strong>AUSTRALIA</strong> CUSTOM/TAX LIKELY APPLY") :
  "CA" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING | <strong>CA</strong> CUSTOM/TAX LIKELY APPLY") :
  

    /* Europe */
     
  "GB" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 5-DAY SHIPPING TO <strong>UK</strong>") :
  "NL" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 5-DAY SHIPPING TO <strong>THE NETHERLANDS</strong>") :
  "AT" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 6-DAY SHIPPING TO <strong>AUSTRIA</strong>") :
  "FR" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 6-DAY SHIPPING TO <strong>FRANCE</strong>") :
  "PL" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 6-DAY SHIPPING TO <strong>POLAND</strong>") :
  "DE" === country_codes ? jQuery(".announcement-bar__message").html("✨ Das neue Caiman-Modell für Damen: Double Tour 🚚 Kostenlose Lieferung in 2-3 Tagen") :
  "IT" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 7-DAY SHIPPING TO <strong>ITALY</strong>") :
  "MC" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 7-DAY SHIPPING TO <strong>MONACO</strong>") :
  "AL" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 8-DAY SHIPPING TO <strong>ALBANIA</strong>") :
  "BE" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 8-DAY SHIPPING TO <strong>BELGIUM</strong>") :
  "HU" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 8-DAY SHIPPING TO <strong>HUNGARY</strong>") :
  "SI" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 8-DAY SHIPPING TO <strong>SLOVENIA</strong>") :
  "ES" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 8-DAY SHIPPING TO <strong>SPAIN</strong>") :
  "CZ" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 9-DAY SHIPPING TO <strong>CZECH REPUBLIC</strong>") :  
  "GI" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 9-DAY SHIPPING TO <strong>GIBRALTAR</strong>") :
  "GG" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 9-DAY SHIPPING TO <strong>GUERNSEY</strong>") :
  "LU" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 9-DAY SHIPPING TO <strong>LUXEMBOURG</strong>") :
  "TR" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 9-DAY SHIPPING TO <strong>TURKEY</strong>") :
  "HR" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING TO <strong>CROATIA</strong>") :
  "IE" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING TO <strong>IRELAND</strong>") :
  "JE" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING TO <strong>JERSEY</strong>") :
  "PT" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING TO <strong>PORTUGAL</strong>") :
  "RO" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING TO <strong>ROMANIA</strong>") :
  "FI" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 11-DAY SHIPPING TO <strong>FINLAND</strong>") :
  "NO" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 11-DAY SHIPPING TO <strong>NORWAY</strong>") :
  "RS" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 11-DAY SHIPPING TO <strong>SERBIA</strong>") :
  "SK" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 11-DAY SHIPPING TO <strong>SLOVAKIA</strong>") :
  "SE" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 11-DAY SHIPPING TO <strong>SWEDEN</strong>") :
  "BG" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 12-DAY SHIPPING TO <strong>BULGARIA</strong>") :  
  "DK" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 12-DAY SHIPPING TO <strong>DENMARK</strong>") :
  "CH" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 12-DAY SHIPPING TO <strong>SWITZERLAND</strong>") :
  "EE" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 13-DAY SHIPPING TO <strong>ESTONIA</strong>") :  
  "IS" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 13-DAY SHIPPING TO <strong>ICELAND</strong>") :
  "LT" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 13-DAY SHIPPING TO <strong>LITHUANIA</strong>") :
  "LV" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 13-DAY SHIPPING TO <strong>LATVIA</strong>") :
  "GR" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 14-DAY SHIPPING TO <strong>GREECE</strong>") :
  "MT" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 14-DAY SHIPPING TO <strong>MALTA</strong>") :

    /* Asia */
  "TW" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 7-DAY SHIPPING IN <strong>TAIWAN</strong>") :
  "SG" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 5-DAY SHIPPING TO <strong>SINGAPORE</strong>") :
  "HK" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 6-DAY SHIPPING IN <strong>HONG KONG</strong>") :  
  "JP" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 7-DAY SHIPPING IN <strong>JAPAN</strong>") :
  "KR" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 13-DAY SHIPPING IN <strong>SOUTH KOREA</strong>") :

    /* GCC */
  "BH" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING IN <strong>BAHRAIN</strong>") :
  "KW" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING IN <strong>KUWAIT</strong>") :
  "OM" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING IN <strong>OMAN</strong>") :
  "QA" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING IN <strong>QATAR</strong>") :
  "SA" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING IN <strong>SA</strong>") :
  "AE" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHPPING IN <strong>UAE</strong>") :

  jQuery(".announcement-bar__message").html("✨ Das neue Caiman-Modell für Damen: Double Tour 🚚 Kostenlose Lieferung in 7 Tagen");
  

 }, "jsonp");
  }else{
 var country_codes = e.country_code;
      console.log(country_codes);
    if("US" === country_codes){
      $(".wus.us" + country_codes).css("display", "block"), jQuery(".der38").css("display", "none"),
			window.customer_warehouse = "US";
			if($('[data-section-type="product-template"]').length) {
		    toggle_in_stock_message();
		  }
		}

   else if("FR" === country_codes || "RU" === country_codes || "DE" === country_codes || "TR" === country_codes || "IT" === country_codes || "ES" === country_codes || "PL" === country_codes || "UA" === country_codes || "RO" === country_codes || "KZ" === country_codes || "NL" === country_codes || "BE" === country_codes || "GR" === country_codes || "CZ" === country_codes || "SE" === country_codes || "PT" === country_codes || "HU" === country_codes || "BG" === country_codes || "RS" === country_codes || "DK" === country_codes || "FI" === country_codes || "SK" === country_codes || "SI" === country_codes  || "NO" === country_codes || "IE" === country_codes || "HR" === country_codes || "GE" === country_codes || "EE" === country_codes || "LU" === country_codes || "IS" === country_codes || "MT" === country_codes || "CY" === country_codes || "LT" === country_codes || "LV" === country_codes || "AL" === country_codes || "MD" === country_codes || "BA" === country_codes || "AM" === country_codes || "MK" === country_codes || "ME" === country_codes || "XK" === country_codes || "CY" === country_codes || "AZ" === country_codes || "AD" === country_codes || "LI" === country_codes || "MC" === country_codes || "VA" === country_codes){
    $(".wus.usEU").css("display", "block"), jQuery(".der38").css("display", "none");
		window.customer_warehouse = "EU";
		if($('[data-section-type="product-template"]').length) {
	    toggle_in_stock_message();
	  }
  } else {
      $(".wus.usHK").css("display", "block").addClass('country-code');
			window.customer_warehouse = "HK";
			if($('[data-section-type="product-template"]').length) {
		    toggle_in_stock_message();
		  }
    }
    
        /* English T1 GEOs */
  "US" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 6-DAY <strong>US</strong> SHIPPING") :
  "NZ" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 9-DAY SHIPPING IN <strong>NZ</strong>") :
  "AU" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING TO <strong>AUSTRALIA</strong> CUSTOM/TAX LIKELY APPLY") :
  "CA" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING | <strong>CA</strong> CUSTOM/TAX LIKELY APPLY") :
  

    /* Europe */
     
  "GB" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 5-DAY SHIPPING TO <strong>UK</strong>") :
  "NL" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 5-DAY SHIPPING TO <strong>THE NETHERLANDS</strong>") :
  "AT" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 6-DAY SHIPPING TO <strong>AUSTRIA</strong>") :
  "FR" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 6-DAY SHIPPING TO <strong>FRANCE</strong>") :
  "PL" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 6-DAY SHIPPING TO <strong>POLAND</strong>") :
  "DE" === country_codes ? jQuery(".announcement-bar__message").html("✨ Das neue Caiman-Modell für Damen: Double Tour 🚚 Kostenlose Lieferung in 2-3 Tagen") :
  "IT" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 7-DAY SHIPPING TO <strong>ITALY</strong>") :
  "MC" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 7-DAY SHIPPING TO <strong>MONACO</strong>") :
  "AL" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 8-DAY SHIPPING TO <strong>ALBANIA</strong>") :
  "BE" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 8-DAY SHIPPING TO <strong>BELGIUM</strong>") :
  "HU" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 8-DAY SHIPPING TO <strong>HUNGARY</strong>") :
  "SI" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 8-DAY SHIPPING TO <strong>SLOVENIA</strong>") :
  "ES" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 8-DAY SHIPPING TO <strong>SPAIN</strong>") :
  "CZ" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 9-DAY SHIPPING TO <strong>CZECH REPUBLIC</strong>") :  
  "GI" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 9-DAY SHIPPING TO <strong>GIBRALTAR</strong>") :
  "GG" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 9-DAY SHIPPING TO <strong>GUERNSEY</strong>") :
  "LU" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 9-DAY SHIPPING TO <strong>LUXEMBOURG</strong>") :
  "TR" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 9-DAY SHIPPING TO <strong>TURKEY</strong>") :
  "HR" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING TO <strong>CROATIA</strong>") :
  "IE" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING TO <strong>IRELAND</strong>") :
  "JE" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING TO <strong>JERSEY</strong>") :
  "PT" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING TO <strong>PORTUGAL</strong>") :
  "RO" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING TO <strong>ROMANIA</strong>") :
  "FI" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 11-DAY SHIPPING TO <strong>FINLAND</strong>") :
  "NO" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 11-DAY SHIPPING TO <strong>NORWAY</strong>") :
  "RS" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 11-DAY SHIPPING TO <strong>SERBIA</strong>") :
  "SK" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 11-DAY SHIPPING TO <strong>SLOVAKIA</strong>") :
  "SE" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 11-DAY SHIPPING TO <strong>SWEDEN</strong>") :
  "BG" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 12-DAY SHIPPING TO <strong>BULGARIA</strong>") :  
  "DK" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 12-DAY SHIPPING TO <strong>DENMARK</strong>") :
  "CH" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 12-DAY SHIPPING TO <strong>SWITZERLAND</strong>") :
  "EE" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 13-DAY SHIPPING TO <strong>ESTONIA</strong>") :  
  "IS" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 13-DAY SHIPPING TO <strong>ICELAND</strong>") :
  "LT" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 13-DAY SHIPPING TO <strong>LITHUANIA</strong>") :
  "LV" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 13-DAY SHIPPING TO <strong>LATVIA</strong>") :
  "GR" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 14-DAY SHIPPING TO <strong>GREECE</strong>") :
  "MT" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 14-DAY SHIPPING TO <strong>MALTA</strong>") :

    /* Asia */
  "TW" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 7-DAY SHIPPING IN <strong>TAIWAN</strong>") :
  "SG" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 5-DAY SHIPPING TO <strong>SINGAPORE</strong>") :
  "HK" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 6-DAY SHIPPING IN <strong>HONG KONG</strong>") :  
  "JP" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 7-DAY SHIPPING IN <strong>JAPAN</strong>") :
  "KR" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 13-DAY SHIPPING IN <strong>SOUTH KOREA</strong>") :

    /* GCC */
  "BH" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING IN <strong>BAHRAIN</strong>") :
  "KW" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING IN <strong>KUWAIT</strong>") :
  "OM" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING IN <strong>OMAN</strong>") :
  "QA" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING IN <strong>QATAR</strong>") :
  "SA" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHIPPING IN <strong>SA</strong>") :
  "AE" === country_codes ? jQuery(".announcement-bar__message").html("✨ The All-New Women's Caiman Series Double Tour ✈️ FREE 10-DAY SHPPING IN <strong>UAE</strong>") :

  jQuery(".announcement-bar__message").html("✨ Das neue Caiman-Modell für Damen: Double Tour 🚚 Kostenlose Lieferung in 7 Tagen");
  
}
}),


$(document).ready(function() {
	if (/*$("body").on("click", "#sil-btn", function() {
					$("#more-color-div ul li").removeClass("active"), $(this).parent().addClass("active"), $(".list_gld").removeClass("hide-me"), $(".list_blk").removeClass("hide-me"), $(".list_sil").toggleClass("hide-me")
			}), $("body").on("click", "#gld-btn", function() {
					$("#more-color-div ul li").removeClass("active"), $(this).parent().addClass("active"), $(".list_sil").removeClass("hide-me"), $(".list_blk").removeClass("hide-me"), $(".list_gld").toggleClass("hide-me")
			}), $("body").on("click", "#blk-btn", function() {
					$("#more-color-div ul li").removeClass("active"), $(this).parent().addClass("active"), $(".list_sil").removeClass("hide-me"), $(".list_gld").removeClass("hide-me"), $(".list_blk").toggleClass("hide-me")
			}),*/

			$("body").on("click", ".my-additional-btn", function() {
					var e = $(this).data("vrnt");
					data = {
							quantity: 1,
							id: e
					}, jQuery.ajax({
							type: "POST",
							url: "/cart/add.js",
							data: data,
							dataType: "json",
							success: function() {
									window.location.href = "/cart"
							}

					})
			}), $("body").on("change", ".cart-swatch.swatch-element input", function() {
        var parent_section = $('[data-master-select]').parents('.shopify-section');
        var e = $(this).parent().data("varid");
        if($(".list-1").length < 1){
          $('select.product-form__master-select').val(e);
          $('input#k_id_sku').val($(this).parent().attr('data-skk'));
          $('select.product-form__master-select').val(e);
          klaviy();
        }else{
          
          var xtext = $(".list-0 .swatch-element.active input").val();
          var xtext1 = $(".list-1 .swatch-element.active input").val();
          var txt2 = xtext +" / "+ xtext1;

          var selected_option = Array.from($('[data-master-select] option')).find(option => option.textContent.includes(txt2));
          
          if(selected_option) {
            $('[data-master-select]').val(selected_option.value).trigger('change');
            $('input#k_id_sku').val(selected_option.dataset.sku);
            klaviy();
            parent_section.find('[data-cart-submit]').prop('disabled', false);
            parent_section.find('[data-cart-submit] [data-cart-primary-submit-text]').show().siblings().hide();
            var htm_cart_btn = $('.price--'+selected_option.value).html();
            $('.prdistxt').html(htm_cart_btn);
            toggle_in_stock_message();
          } else {
            console.log('variant does not exist');
            
            parent_section.find('[data-cart-submit]').prop('disabled', true).show();
            parent_section.find('[data-cart-submit] [data-submit-button-unavailable-text]').show().siblings().hide();
            parent_section.find('.in-stock-message').hide();
            parent_section.find('#email_signup3').hide();

          }
        }
        
        var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + $('select.product-form__master-select').val();
        window.history.replaceState({ path: newUrl }, '', newUrl);

     }), $(window).width() > 767) {
			$("body").on("click", "#more-btn", function() {
					var e = $(".sec-half").height();
					e > $(".fst-half").height() ? $(".fst-half").height(e) : $(".fst-half").height(), $(".sec-half").height($(".fst-half").height())
			});
			var e = $(".sec-half").height();
			e > $(".fst-half").height() && $(".fst-half").height(e)
	}
});

$('span.color-slider-click.clk').click(function(){

$(this).parent().find('span.color-slider-click.clk').removeClass('active');
//$(this).parent().find('span.color-slider-click.clk').removeClass('active2');

$(this).addClass('active');
//$(this).addClass('active2');
var xttext1 = $(this).text();
var xtext = $(this).parent().parent().find('.active1').text();

var txt2 = xttext1 +" / "+ xtext
$(this).parent().parent().find('select.slider--col option').each(function(){
var txt = $(this).text();
if(txt.indexOf(txt2) != -1){
var vdrid =  $(this).val();
var stck = $(this).data('stock');
 $(this).parent().parent().parent().find('.my-additional-btn').attr('data-vrnt', vdrid);
$(this).parent().parent().parent().find('input.check--color').val(vdrid);
//console.log(stck);
 if(stck){
 if(stck.indexOf('deny') != -1){
$(this).parent().parent().parent().find('.my-additional-btn').text('Ausverkauft').css('pointer-events', 'none') ;
}else{
	$(this).parent().parent().parent().find('.my-additional-btn').text('In den Einkaufswagen legen').css('pointer-events', '') ;
}
 }
// console.log('hhhhhhhhhhhhhhhhhhhhhhhhhhh'+$('.prr-'+vdrid).html());
$(this).parent().parent().parent().find("span.prc.cart-prrice").html($('.prr-'+vdrid).html());
$(this).parent().parent().parent().find('span.pric').html($('.prr-'+vdrid).html());
$(this).parent().val(vdrid);
 var chkq = $(this).data('policy');
if(chkq){
if(chkq.indexOf('deny') != -1){
	if($(this).parent().parent().parent().find('input.check--color').prop("checked") == true){
						 $(this).parent().parent().parent().find('input.check--color').trigger('click');
					}
$(this).parent().parent().parent().find('input.check--color').attr('disabled', 'true');
$(this).parent().parent().parent().find('span.prc.supple__price--hidden').text('Ausverkauft');
}else{
$(this).parent().parent().parent().find('input.check--color').removeAttr('disabled');
	$(this).parent().parent().parent().find('span.prc.supple__price--hidden').html($('.prr-'+vdrid).html());
}
}
}
});
});
$('span.color-slider-click.ckl').click(function(){

$(this).parent().find('span.color-slider-click.ckl').removeClass('active1');
//$(this).parent().find('span.color-slider-click.ckl').removeClass('active1');
$(this).addClass('active1');
var xttext1 = $(this).text();
var xtext = $(this).parent().parent().find('.active').text();

var txt2 = xtext +" / "+ xttext1
$(this).parent().parent().find('select.slider--col option').each(function(){
var txt = $(this).text();
if(txt.indexOf(txt2) != -1){
var vdrid =  $(this).val();
var stck = $(this).data('stock');

 $(this).parent().parent().parent().find('.my-additional-btn').attr('data-vrnt', vdrid);
$(this).parent().parent().parent().find('input.check--color').val(vdrid);
//console.log(stck);
 if(stck){
if(stck.indexOf('deny') != -1){
$(this).parent().parent().parent().find('.my-additional-btn').text('Ausverkauft').css('pointer-events', 'none') ;
}else{
	$(this).parent().parent().parent().find('.my-additional-btn').text('In den Einkaufswagen legen').css('pointer-events', '') ;
}
 }$(this).parent().parent().parent().find("span.prc.cart-prrice").html($('.prr-'+vdrid).html());
// console.log('hhhhhhhhhhhhhhhhhhhhhhhhhhh'+$('.prr-'+vdrid).html());
	$(this).parent().parent().parent().find('span.pric').html($('.prr-'+vdrid).html());
$(this).parent().val(vdrid);
 var chkq = $(this).data('policy');
 if(chkq){
if(chkq.indexOf('deny') != -1){
			if($(this).parent().parent().parent().find('input.check--color').prop("checked") == true){
						 $(this).parent().parent().parent().find('input.check--color').trigger('click');
					}
$(this).parent().parent().parent().find('input.check--color').attr('disabled', 'true');
$(this).parent().parent().parent().find('span.prc.supple__price--hidden').text('Ausverkauft');
}else{
	$(this).parent().parent().parent().find('span.prc.supple__price--hidden').html($('.prr-'+vdrid).html());
$(this).parent().parent().parent().find('input.check--color').removeAttr('disabled');
}
 }
}
});

});

$('.clickk-col').click(function(){
if(!$(this).hasClass('c-active')){
$('.clickk-col').removeClass('c-active');
$('.tabcontent').removeClass('c--active');
$(this).addClass('c-active').next().addClass('c--active');
}else{
	$(this).removeClass('c-active').next().removeClass('c--active');}
if($(this).next().next().hasClass('fr-strap')){
		if($(this).next().next().hasClass('fr02')){
 $(this).next().next().removeClass('fr02');
		}else{
$(this).next().next().addClass('fr02');
}
}
if($(this).hasClass('fr02')){
$(this).removeClass('fr02')
}
});

$('span.size--gide-main').click(function(){
$('.abu').show();
});
$('.ab-close').click(function(){
$('.abu').hide();
$('.abu-ques').hide();
});

$('.list-0 span.qusmark').click(function(){
$('.abu-ques').show();
});
setTimeout(function(){
var tct = $('select.product-form__master-select.supports-no-js option:selected').data('cartbtn');
$('.prdistxt').html(tct);

}, 800);

setTimeout(function(){
var tct = $('select.product-form__master-select.supports-no-js option:selected').data('cartbtn');
$('.prdistxt').html(tct);

}, 1500);

// setTimeout(function(){
// var vl = $('select[name="currencies"]').val();
// console.log(vl);
// $('select[name="currencies"] option[value="'+vl+'"]').trigger('chnage');

//   $('span.primary-text.prdistxt').html($('.pri---price').html());
// }, 5000);

$('[data-shipping-info-changer]').change(function(e){
$(`.${$(this).val()}`).removeClass('hidden').siblings('.shipping-info').addClass('hidden');
});

$(document).on('click', '.custom-footer-opener, .custom-faq-question-title', function(e) {
e.preventDefault();
$(this).toggleClass('opened');
$(this).next().slideToggle();
});

document.addEventListener('DOMContentLoaded', function(){

	function set_element_height_into_variable(parent_container, element_to_measure, css_var_name) {
    height = $(element_to_measure).outerHeight(true);
    $(parent_container)[0].style.setProperty(`--${css_var_name}`, height + 'px');
  }

	set_element_height_into_variable('body', '#shopify-section-custom-header', 'header_height');


	$(window).on('load', function(){
    set_element_height_into_variable('body', '#shopify-section-custom-header', 'header_height');
  });

  $(window).on('resize', function(){
    set_element_height_into_variable('body', '#shopify-section-custom-header', 'header_height');
  });

	if(!sessionStorage.getItem("announcement-bar-hidden")) {
		$('.announcement-bar').slideDown();
	}

	$(document).on('click', '.announcement-bar__close', function(e) {
		e.preventDefault();
		$('.announcement-bar').slideUp();
		sessionStorage.setItem("announcement-bar-hidden", !0);
	});

	$(document).on('click', '[data-open-mobile-menu]', function(e) {
		e.preventDefault();
		$('[data-header-overlay]').fadeIn();
		$('.custom-mobile-sidebar').addClass('opened');
	});

	$(document).on('click', '[data-close-mobile-menu]', function(e) {
		e.preventDefault();
		$('[data-header-overlay]').fadeOut();
		$('.custom-mobile-sidebar').removeClass('opened');
	});

	$(document).on('click', '[data-next-level]', function(e) {
		e.preventDefault();
		next_level_menu = $(this).data('next-level');
		new_title = $(this).data('title');
		$('[data-sidebar-header]').html(new_title);
		$('.custom-mobile-sidebar').removeClass('level-1-visible').addClass('level-2-visible');
		$('.cms-body-content.level-2').removeClass('visible');
		$(`[data-parent-link="${next_level_menu}"]`).addClass('visible');
	});

	$(document).on('click', '[data-sidebar-previous-level]', function(e) {
		e.preventDefault();
		new_title = $('[data-sidebar-header]').data('title');
		$('[data-sidebar-header]').html(new_title);
		$('.cms-body-content.level-2').removeClass('visible');
		$('.custom-mobile-sidebar').removeClass('level-2-visible').addClass('level-1-visible');
	});

	$(document).on('click', '[data-toggle-adaptor-finish-popup]', function(e) {
    e.preventDefault();
    $('[data-adaptor-finish-popup]').toggleClass('opened');
  });

	// Cart featured collections
  $(document).on('click', '[data-open-featured-collection]', function(e) {
    e.preventDefault();
    var collection_to_display = $(this).data('open-featured-collection');
    $('[data-featured-collection-changer-container]').fadeIn();
    $('[data-featured-collections-header]').slideUp();
    $(`[data-featured-collection="${collection_to_display}"]`).show().siblings().hide();
    $(`[data-featured-collection="${collection_to_display}"]`).slick('refresh');
    $('[data-featured-collections]').fadeIn();
  });

  $(document).on('click', '[data-featured-collection-changer]', function(e) {
    e.preventDefault();
    $('[data-featured-collections-header]').slideDown();
    $('[data-featured-collections]').fadeOut();
    $('[data-featured-collection-changer-container]').fadeOut();
  });
});


window.addEventListener("load", function(){
  if ($('.custom-faq-question').length && location.hash) {
    setTimeout(function(){
      $(window).scrollTop($(location.hash).offset().top);
      $(location.hash).find('.custom-faq-question-title').click();
    }, 500);
  }
});
